import { registerComponent as _t } from "@aileron/button";
import { registerComponent as Re } from "@aileron/button-icon";
import { registerComponent as At } from "@aileron/dialog";
import { registerComponent as Ot } from "@aileron/icon";
import { registerComponent as Nt } from "@aileron/tabs";
import { registerComponent as Rt } from "@aileron/text-input";
import { createSlice as It, configureStore as dt } from "@reduxjs/toolkit";
import { isSameMonth as de, parseISO as f, isAfter as Ie, format as ht, isToday as ut, isSameDay as oe, isBefore as A, isThisYear as zt, startOfDay as I, add as ft, startOfWeek as Pt } from "date-fns";
import * as Ee from "date-fns/locale/index.js";
import { unsafeCSS as Te, LitElement as Vt } from "lit";
import { unsafeStatic as ze, html as E } from "lit/static-html.js";
import { property as y, state as M, queryAll as De, query as q, queryAsync as pt } from "lit/decorators.js";
import { classMap as L } from "lit/directives/class-map.js";
import { styleMap as mt } from "lit/directives/style-map.js";
import { v1 as Bt } from "uuid";
const Wt = ["top", "right", "bottom", "left"], ye = Math.min, K = Math.max, xe = Math.round, me = Math.floor, J = (e) => ({
  x: e,
  y: e
}), jt = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Jt = {
  start: "end",
  end: "start"
};
function Xe(e, t, i) {
  return K(e, ye(t, i));
}
function ue(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function G(e) {
  return e.split("-")[0];
}
function Ce(e) {
  return e.split("-")[1];
}
function gt(e) {
  return e === "x" ? "y" : "x";
}
function bt(e) {
  return e === "y" ? "height" : "width";
}
function Me(e) {
  return ["top", "bottom"].includes(G(e)) ? "y" : "x";
}
function wt(e) {
  return gt(Me(e));
}
function Yt(e, t, i) {
  i === void 0 && (i = !1);
  const o = Ce(e), r = wt(e), a = bt(r);
  let n = r === "x" ? o === (i ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[a] > t.floating[a] && (n = Se(n)), [n, Se(n)];
}
function qt(e) {
  const t = Se(e);
  return [Ae(e), t, Ae(t)];
}
function Ae(e) {
  return e.replace(/start|end/g, (t) => Jt[t]);
}
function Ht(e, t, i) {
  const o = ["left", "right"], r = ["right", "left"], a = ["top", "bottom"], n = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return i ? t ? r : o : t ? o : r;
    case "left":
    case "right":
      return t ? a : n;
    default:
      return [];
  }
}
function Ut(e, t, i, o) {
  const r = Ce(e);
  let a = Ht(G(e), i === "start", o);
  return r && (a = a.map((n) => n + "-" + r), t && (a = a.concat(a.map(Ae)))), a;
}
function Se(e) {
  return e.replace(/left|right|bottom|top/g, (t) => jt[t]);
}
function Kt(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function Gt(e) {
  return typeof e != "number" ? Kt(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function ve(e) {
  return {
    ...e,
    top: e.y,
    left: e.x,
    right: e.x + e.width,
    bottom: e.y + e.height
  };
}
function Qe(e, t, i) {
  let {
    reference: o,
    floating: r
  } = e;
  const a = Me(t), n = wt(t), s = bt(n), l = G(t), d = a === "y", c = o.x + o.width / 2 - r.width / 2, h = o.y + o.height / 2 - r.height / 2, p = o[s] / 2 - r[s] / 2;
  let u;
  switch (l) {
    case "top":
      u = {
        x: c,
        y: o.y - r.height
      };
      break;
    case "bottom":
      u = {
        x: c,
        y: o.y + o.height
      };
      break;
    case "right":
      u = {
        x: o.x + o.width,
        y: h
      };
      break;
    case "left":
      u = {
        x: o.x - r.width,
        y: h
      };
      break;
    default:
      u = {
        x: o.x,
        y: o.y
      };
  }
  switch (Ce(t)) {
    case "start":
      u[n] -= p * (i && d ? -1 : 1);
      break;
    case "end":
      u[n] += p * (i && d ? -1 : 1);
      break;
  }
  return u;
}
const Xt = async (e, t, i) => {
  const {
    placement: o = "bottom",
    strategy: r = "absolute",
    middleware: a = [],
    platform: n
  } = i, s = a.filter(Boolean), l = await (n.isRTL == null ? void 0 : n.isRTL(t));
  let d = await n.getElementRects({
    reference: e,
    floating: t,
    strategy: r
  }), {
    x: c,
    y: h
  } = Qe(d, o, l), p = o, u = {}, b = 0;
  for (let w = 0; w < s.length; w++) {
    const {
      name: x,
      fn: S
    } = s[w], {
      x: T,
      y: C,
      data: F,
      reset: $
    } = await S({
      x: c,
      y: h,
      initialPlacement: o,
      placement: p,
      strategy: r,
      middlewareData: u,
      rects: d,
      platform: n,
      elements: {
        reference: e,
        floating: t
      }
    });
    c = T ?? c, h = C ?? h, u = {
      ...u,
      [x]: {
        ...u[x],
        ...F
      }
    }, $ && b <= 50 && (b++, typeof $ == "object" && ($.placement && (p = $.placement), $.rects && (d = $.rects === !0 ? await n.getElementRects({
      reference: e,
      floating: t,
      strategy: r
    }) : $.rects), {
      x: c,
      y: h
    } = Qe(d, p, l)), w = -1);
  }
  return {
    x: c,
    y: h,
    placement: p,
    strategy: r,
    middlewareData: u
  };
};
async function ke(e, t) {
  var i;
  t === void 0 && (t = {});
  const {
    x: o,
    y: r,
    platform: a,
    rects: n,
    elements: s,
    strategy: l
  } = e, {
    boundary: d = "clippingAncestors",
    rootBoundary: c = "viewport",
    elementContext: h = "floating",
    altBoundary: p = !1,
    padding: u = 0
  } = ue(t, e), b = Gt(u), x = s[p ? h === "floating" ? "reference" : "floating" : h], S = ve(await a.getClippingRect({
    element: (i = await (a.isElement == null ? void 0 : a.isElement(x))) == null || i ? x : x.contextElement || await (a.getDocumentElement == null ? void 0 : a.getDocumentElement(s.floating)),
    boundary: d,
    rootBoundary: c,
    strategy: l
  })), T = h === "floating" ? {
    ...n.floating,
    x: o,
    y: r
  } : n.reference, C = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(s.floating)), F = await (a.isElement == null ? void 0 : a.isElement(C)) ? await (a.getScale == null ? void 0 : a.getScale(C)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, $ = ve(a.convertOffsetParentRelativeRectToViewportRelativeRect ? await a.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: T,
    offsetParent: C,
    strategy: l
  }) : T);
  return {
    top: (S.top - $.top + b.top) / F.y,
    bottom: ($.bottom - S.bottom + b.bottom) / F.y,
    left: (S.left - $.left + b.left) / F.x,
    right: ($.right - S.right + b.right) / F.x
  };
}
const Qt = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var i, o;
      const {
        placement: r,
        middlewareData: a,
        rects: n,
        initialPlacement: s,
        platform: l,
        elements: d
      } = t, {
        mainAxis: c = !0,
        crossAxis: h = !0,
        fallbackPlacements: p,
        fallbackStrategy: u = "bestFit",
        fallbackAxisSideDirection: b = "none",
        flipAlignment: w = !0,
        ...x
      } = ue(e, t);
      if ((i = a.arrow) != null && i.alignmentOffset)
        return {};
      const S = G(r), T = G(s) === s, C = await (l.isRTL == null ? void 0 : l.isRTL(d.floating)), F = p || (T || !w ? [Se(s)] : qt(s));
      !p && b !== "none" && F.push(...Ut(s, w, b, C));
      const $ = [s, ...F], H = await ke(t, x), pe = [];
      let ae = ((o = a.flip) == null ? void 0 : o.overflows) || [];
      if (c && pe.push(H[S]), h) {
        const U = Yt(r, n, C);
        pe.push(H[U[0]], H[U[1]]);
      }
      if (ae = [...ae, {
        placement: r,
        overflows: pe
      }], !pe.every((U) => U <= 0)) {
        var He, Ue;
        const U = (((He = a.flip) == null ? void 0 : He.index) || 0) + 1, Ge = $[U];
        if (Ge)
          return {
            data: {
              index: U,
              overflows: ae
            },
            reset: {
              placement: Ge
            }
          };
        let se = (Ue = ae.filter((Z) => Z.overflows[0] <= 0).sort((Z, ee) => Z.overflows[1] - ee.overflows[1])[0]) == null ? void 0 : Ue.placement;
        if (!se)
          switch (u) {
            case "bestFit": {
              var Ke;
              const Z = (Ke = ae.map((ee) => [ee.placement, ee.overflows.filter((le) => le > 0).reduce((le, Ft) => le + Ft, 0)]).sort((ee, le) => ee[1] - le[1])[0]) == null ? void 0 : Ke[0];
              Z && (se = Z);
              break;
            }
            case "initialPlacement":
              se = s;
              break;
          }
        if (r !== se)
          return {
            reset: {
              placement: se
            }
          };
      }
      return {};
    }
  };
};
function Ze(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function et(e) {
  return Wt.some((t) => e[t] >= 0);
}
const Zt = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: i
      } = t, {
        strategy: o = "referenceHidden",
        ...r
      } = ue(e, t);
      switch (o) {
        case "referenceHidden": {
          const a = await ke(t, {
            ...r,
            elementContext: "reference"
          }), n = Ze(a, i.reference);
          return {
            data: {
              referenceHiddenOffsets: n,
              referenceHidden: et(n)
            }
          };
        }
        case "escaped": {
          const a = await ke(t, {
            ...r,
            altBoundary: !0
          }), n = Ze(a, i.floating);
          return {
            data: {
              escapedOffsets: n,
              escaped: et(n)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function ei(e, t) {
  const {
    placement: i,
    platform: o,
    elements: r
  } = e, a = await (o.isRTL == null ? void 0 : o.isRTL(r.floating)), n = G(i), s = Ce(i), l = Me(i) === "y", d = ["left", "top"].includes(n) ? -1 : 1, c = a && l ? -1 : 1, h = ue(t, e);
  let {
    mainAxis: p,
    crossAxis: u,
    alignmentAxis: b
  } = typeof h == "number" ? {
    mainAxis: h,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...h
  };
  return s && typeof b == "number" && (u = s === "end" ? b * -1 : b), l ? {
    x: u * c,
    y: p * d
  } : {
    x: p * d,
    y: u * c
  };
}
const ti = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var i, o;
      const {
        x: r,
        y: a,
        placement: n,
        middlewareData: s
      } = t, l = await ei(t, e);
      return n === ((i = s.offset) == null ? void 0 : i.placement) && (o = s.arrow) != null && o.alignmentOffset ? {} : {
        x: r + l.x,
        y: a + l.y,
        data: {
          ...l,
          placement: n
        }
      };
    }
  };
}, ii = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: i,
        y: o,
        placement: r
      } = t, {
        mainAxis: a = !0,
        crossAxis: n = !1,
        limiter: s = {
          fn: (x) => {
            let {
              x: S,
              y: T
            } = x;
            return {
              x: S,
              y: T
            };
          }
        },
        ...l
      } = ue(e, t), d = {
        x: i,
        y: o
      }, c = await ke(t, l), h = Me(G(r)), p = gt(h);
      let u = d[p], b = d[h];
      if (a) {
        const x = p === "y" ? "top" : "left", S = p === "y" ? "bottom" : "right", T = u + c[x], C = u - c[S];
        u = Xe(T, u, C);
      }
      if (n) {
        const x = h === "y" ? "top" : "left", S = h === "y" ? "bottom" : "right", T = b + c[x], C = b - c[S];
        b = Xe(T, b, C);
      }
      const w = s.fn({
        ...t,
        [p]: u,
        [h]: b
      });
      return {
        ...w,
        data: {
          x: w.x - i,
          y: w.y - o
        }
      };
    }
  };
};
function Y(e) {
  return yt(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function O(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function B(e) {
  var t;
  return (t = (yt(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function yt(e) {
  return e instanceof Node || e instanceof O(e).Node;
}
function V(e) {
  return e instanceof Element || e instanceof O(e).Element;
}
function z(e) {
  return e instanceof HTMLElement || e instanceof O(e).HTMLElement;
}
function tt(e) {
  return typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof O(e).ShadowRoot;
}
function fe(e) {
  const {
    overflow: t,
    overflowX: i,
    overflowY: o,
    display: r
  } = R(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + i) && !["inline", "contents"].includes(r);
}
function oi(e) {
  return ["table", "td", "th"].includes(Y(e));
}
function Pe(e) {
  const t = Ve(), i = R(e);
  return i.transform !== "none" || i.perspective !== "none" || (i.containerType ? i.containerType !== "normal" : !1) || !t && (i.backdropFilter ? i.backdropFilter !== "none" : !1) || !t && (i.filter ? i.filter !== "none" : !1) || ["transform", "perspective", "filter"].some((o) => (i.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (i.contain || "").includes(o));
}
function ri(e) {
  let t = re(e);
  for (; z(t) && !$e(t); ) {
    if (Pe(t))
      return t;
    t = re(t);
  }
  return null;
}
function Ve() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function $e(e) {
  return ["html", "body", "#document"].includes(Y(e));
}
function R(e) {
  return O(e).getComputedStyle(e);
}
function Le(e) {
  return V(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.pageXOffset,
    scrollTop: e.pageYOffset
  };
}
function re(e) {
  if (Y(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    tt(e) && e.host || // Fallback.
    B(e)
  );
  return tt(t) ? t.host : t;
}
function xt(e) {
  const t = re(e);
  return $e(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : z(t) && fe(t) ? t : xt(t);
}
function he(e, t, i) {
  var o;
  t === void 0 && (t = []), i === void 0 && (i = !0);
  const r = xt(e), a = r === ((o = e.ownerDocument) == null ? void 0 : o.body), n = O(r);
  return a ? t.concat(n, n.visualViewport || [], fe(r) ? r : [], n.frameElement && i ? he(n.frameElement) : []) : t.concat(r, he(r, [], i));
}
function St(e) {
  const t = R(e);
  let i = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const r = z(e), a = r ? e.offsetWidth : i, n = r ? e.offsetHeight : o, s = xe(i) !== a || xe(o) !== n;
  return s && (i = a, o = n), {
    width: i,
    height: o,
    $: s
  };
}
function Be(e) {
  return V(e) ? e : e.contextElement;
}
function ie(e) {
  const t = Be(e);
  if (!z(t))
    return J(1);
  const i = t.getBoundingClientRect(), {
    width: o,
    height: r,
    $: a
  } = St(t);
  let n = (a ? xe(i.width) : i.width) / o, s = (a ? xe(i.height) : i.height) / r;
  return (!n || !Number.isFinite(n)) && (n = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: n,
    y: s
  };
}
const ni = /* @__PURE__ */ J(0);
function vt(e) {
  const t = O(e);
  return !Ve() || !t.visualViewport ? ni : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function ai(e, t, i) {
  return t === void 0 && (t = !1), !i || t && i !== O(e) ? !1 : t;
}
function X(e, t, i, o) {
  t === void 0 && (t = !1), i === void 0 && (i = !1);
  const r = e.getBoundingClientRect(), a = Be(e);
  let n = J(1);
  t && (o ? V(o) && (n = ie(o)) : n = ie(e));
  const s = ai(a, i, o) ? vt(a) : J(0);
  let l = (r.left + s.x) / n.x, d = (r.top + s.y) / n.y, c = r.width / n.x, h = r.height / n.y;
  if (a) {
    const p = O(a), u = o && V(o) ? O(o) : o;
    let b = p, w = b.frameElement;
    for (; w && o && u !== b; ) {
      const x = ie(w), S = w.getBoundingClientRect(), T = R(w), C = S.left + (w.clientLeft + parseFloat(T.paddingLeft)) * x.x, F = S.top + (w.clientTop + parseFloat(T.paddingTop)) * x.y;
      l *= x.x, d *= x.y, c *= x.x, h *= x.y, l += C, d += F, b = O(w), w = b.frameElement;
    }
  }
  return ve({
    width: c,
    height: h,
    x: l,
    y: d
  });
}
const si = [":popover-open", ":modal"];
function kt(e) {
  return si.some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function li(e) {
  let {
    elements: t,
    rect: i,
    offsetParent: o,
    strategy: r
  } = e;
  const a = r === "fixed", n = B(o), s = t ? kt(t.floating) : !1;
  if (o === n || s && a)
    return i;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, d = J(1);
  const c = J(0), h = z(o);
  if ((h || !h && !a) && ((Y(o) !== "body" || fe(n)) && (l = Le(o)), z(o))) {
    const p = X(o);
    d = ie(o), c.x = p.x + o.clientLeft, c.y = p.y + o.clientTop;
  }
  return {
    width: i.width * d.x,
    height: i.height * d.y,
    x: i.x * d.x - l.scrollLeft * d.x + c.x,
    y: i.y * d.y - l.scrollTop * d.y + c.y
  };
}
function ci(e) {
  return Array.from(e.getClientRects());
}
function Tt(e) {
  return X(B(e)).left + Le(e).scrollLeft;
}
function di(e) {
  const t = B(e), i = Le(e), o = e.ownerDocument.body, r = K(t.scrollWidth, t.clientWidth, o.scrollWidth, o.clientWidth), a = K(t.scrollHeight, t.clientHeight, o.scrollHeight, o.clientHeight);
  let n = -i.scrollLeft + Tt(e);
  const s = -i.scrollTop;
  return R(o).direction === "rtl" && (n += K(t.clientWidth, o.clientWidth) - r), {
    width: r,
    height: a,
    x: n,
    y: s
  };
}
function hi(e, t) {
  const i = O(e), o = B(e), r = i.visualViewport;
  let a = o.clientWidth, n = o.clientHeight, s = 0, l = 0;
  if (r) {
    a = r.width, n = r.height;
    const d = Ve();
    (!d || d && t === "fixed") && (s = r.offsetLeft, l = r.offsetTop);
  }
  return {
    width: a,
    height: n,
    x: s,
    y: l
  };
}
function ui(e, t) {
  const i = X(e, !0, t === "fixed"), o = i.top + e.clientTop, r = i.left + e.clientLeft, a = z(e) ? ie(e) : J(1), n = e.clientWidth * a.x, s = e.clientHeight * a.y, l = r * a.x, d = o * a.y;
  return {
    width: n,
    height: s,
    x: l,
    y: d
  };
}
function it(e, t, i) {
  let o;
  if (t === "viewport")
    o = hi(e, i);
  else if (t === "document")
    o = di(B(e));
  else if (V(t))
    o = ui(t, i);
  else {
    const r = vt(e);
    o = {
      ...t,
      x: t.x - r.x,
      y: t.y - r.y
    };
  }
  return ve(o);
}
function Dt(e, t) {
  const i = re(e);
  return i === t || !V(i) || $e(i) ? !1 : R(i).position === "fixed" || Dt(i, t);
}
function fi(e, t) {
  const i = t.get(e);
  if (i)
    return i;
  let o = he(e, [], !1).filter((s) => V(s) && Y(s) !== "body"), r = null;
  const a = R(e).position === "fixed";
  let n = a ? re(e) : e;
  for (; V(n) && !$e(n); ) {
    const s = R(n), l = Pe(n);
    !l && s.position === "fixed" && (r = null), (a ? !l && !r : !l && s.position === "static" && !!r && ["absolute", "fixed"].includes(r.position) || fe(n) && !l && Dt(e, n)) ? o = o.filter((c) => c !== n) : r = s, n = re(n);
  }
  return t.set(e, o), o;
}
function pi(e) {
  let {
    element: t,
    boundary: i,
    rootBoundary: o,
    strategy: r
  } = e;
  const n = [...i === "clippingAncestors" ? fi(t, this._c) : [].concat(i), o], s = n[0], l = n.reduce((d, c) => {
    const h = it(t, c, r);
    return d.top = K(h.top, d.top), d.right = ye(h.right, d.right), d.bottom = ye(h.bottom, d.bottom), d.left = K(h.left, d.left), d;
  }, it(t, s, r));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function mi(e) {
  const {
    width: t,
    height: i
  } = St(e);
  return {
    width: t,
    height: i
  };
}
function gi(e, t, i) {
  const o = z(t), r = B(t), a = i === "fixed", n = X(e, !0, a, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = J(0);
  if (o || !o && !a)
    if ((Y(t) !== "body" || fe(r)) && (s = Le(t)), o) {
      const h = X(t, !0, a, t);
      l.x = h.x + t.clientLeft, l.y = h.y + t.clientTop;
    } else
      r && (l.x = Tt(r));
  const d = n.left + s.scrollLeft - l.x, c = n.top + s.scrollTop - l.y;
  return {
    x: d,
    y: c,
    width: n.width,
    height: n.height
  };
}
function ot(e, t) {
  return !z(e) || R(e).position === "fixed" ? null : t ? t(e) : e.offsetParent;
}
function Ct(e, t) {
  const i = O(e);
  if (!z(e) || kt(e))
    return i;
  let o = ot(e, t);
  for (; o && oi(o) && R(o).position === "static"; )
    o = ot(o, t);
  return o && (Y(o) === "html" || Y(o) === "body" && R(o).position === "static" && !Pe(o)) ? i : o || ri(e) || i;
}
const bi = async function(e) {
  const t = this.getOffsetParent || Ct, i = this.getDimensions;
  return {
    reference: gi(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      ...await i(e.floating)
    }
  };
};
function wi(e) {
  return R(e).direction === "rtl";
}
const yi = {
  convertOffsetParentRelativeRectToViewportRelativeRect: li,
  getDocumentElement: B,
  getClippingRect: pi,
  getOffsetParent: Ct,
  getElementRects: bi,
  getClientRects: ci,
  getDimensions: mi,
  getScale: ie,
  isElement: V,
  isRTL: wi
};
function xi(e, t) {
  let i = null, o;
  const r = B(e);
  function a() {
    var s;
    clearTimeout(o), (s = i) == null || s.disconnect(), i = null;
  }
  function n(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), a();
    const {
      left: d,
      top: c,
      width: h,
      height: p
    } = e.getBoundingClientRect();
    if (s || t(), !h || !p)
      return;
    const u = me(c), b = me(r.clientWidth - (d + h)), w = me(r.clientHeight - (c + p)), x = me(d), T = {
      rootMargin: -u + "px " + -b + "px " + -w + "px " + -x + "px",
      threshold: K(0, ye(1, l)) || 1
    };
    let C = !0;
    function F($) {
      const H = $[0].intersectionRatio;
      if (H !== l) {
        if (!C)
          return n();
        H ? n(!1, H) : o = setTimeout(() => {
          n(!1, 1e-7);
        }, 100);
      }
      C = !1;
    }
    try {
      i = new IntersectionObserver(F, {
        ...T,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      i = new IntersectionObserver(F, T);
    }
    i.observe(e);
  }
  return n(!0), a;
}
function Si(e, t, i, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: a = !0,
    elementResize: n = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = o, d = Be(e), c = r || a ? [...d ? he(d) : [], ...he(t)] : [];
  c.forEach((S) => {
    r && S.addEventListener("scroll", i, {
      passive: !0
    }), a && S.addEventListener("resize", i);
  });
  const h = d && s ? xi(d, i) : null;
  let p = -1, u = null;
  n && (u = new ResizeObserver((S) => {
    let [T] = S;
    T && T.target === d && u && (u.unobserve(t), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var C;
      (C = u) == null || C.observe(t);
    })), i();
  }), d && !l && u.observe(d), u.observe(t));
  let b, w = l ? X(e) : null;
  l && x();
  function x() {
    const S = X(e);
    w && (S.x !== w.x || S.y !== w.y || S.width !== w.width || S.height !== w.height) && i(), w = S, b = requestAnimationFrame(x);
  }
  return i(), () => {
    var S;
    c.forEach((T) => {
      r && T.removeEventListener("scroll", i), a && T.removeEventListener("resize", i);
    }), h == null || h(), (S = u) == null || S.disconnect(), u = null, l && cancelAnimationFrame(b);
  };
}
const vi = ii, ki = Qt, Ti = Zt, Di = (e, t, i) => {
  const o = /* @__PURE__ */ new Map(), r = {
    platform: yi,
    ...i
  }, a = {
    ...r.platform,
    _c: o
  };
  return Xt(e, t, {
    ...r,
    platform: a
  });
};
class Ci {
  constructor(t, i) {
    this.host = t, this.source = i, this.source.style.position = "absolute", this.source.style.zIndex = "1", this.source.style.display = "none", this.source.style.top = "0px", this.source.style.left = "0px", this.cleanup;
  }
  update() {
    this.cleanup = Si(this.host, this.source, () => {
      Di(this.host, this.source, {
        placement: "bottom",
        middleware: [ti(8), ki(), vi({ padding: 8 }), Ti()]
      }).then(({ x: t, y: i }) => {
        Object.assign(this.source.style, {
          left: `${t}px`,
          top: `${i}px`
        });
      }).catch((t) => {
        console.log("dropdown error: ", t);
      });
    });
  }
  async showDropdown() {
    await this.update(), this.source.style.display = "block";
  }
  hideDropdown() {
    this.source.style.display = "none", this.cleanup && this.cleanup();
  }
}
function N(e, t, i) {
  const o = new CustomEvent(t, {
    bubbles: !0,
    cancelable: !1,
    composed: !0,
    detail: {},
    ...i
  });
  return e.dispatchEvent(o), o;
}
const ce = {
  "en-GB": {
    closeText: "Close",
    prevText: "Prev",
    nextText: "Next",
    currentText: "Today",
    monthNames: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    monthNamesShort: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    dayNames: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"],
    weekHeader: "Wk",
    dateFormat: "dd/mm/yyyy",
    firstDay: 1,
    isRTL: !1,
    showMonthAfterYear: !1,
    yearSuffix: ""
  },
  en: {
    closeText: "Close",
    prevText: "Prev",
    nextText: "Next",
    currentText: "Today",
    monthNames: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    monthNamesShort: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    dayNames: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"],
    weekHeader: "Wk",
    dateFormat: "mm/dd/yyyy",
    firstDay: 0,
    isRTL: !1,
    showMonthAfterYear: !1,
    yearSuffix: ""
  },
  "es-US": {
    closeText: "Cerrar",
    prevText: "&#x3c;Ant",
    nextText: "Sig&#x3e;",
    currentText: "Hoy",
    monthNames: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    ],
    monthNamesShort: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic"
    ],
    dayNames: [
      "Domingo",
      "Lunes",
      "Martes",
      "Mi&eacute;rcoles",
      "Jueves",
      "Viernes",
      "S&aacute;bado"
    ],
    dayNamesShort: [
      "Dom",
      "Lun",
      "Mar",
      "Mi&eacute;",
      "Juv",
      "Vie",
      "S&aacute;b"
    ],
    dayNamesMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "S&aacute;"],
    weekHeader: "Sm",
    dateFormat: "mm/dd/yyyy",
    firstDay: 0,
    isRTL: !1,
    showMonthAfterYear: !1,
    yearSuffix: "",
    yearMask: "aaaa"
  },
  es: {
    closeText: "Cerrar",
    prevText: "&#x3c;Ant",
    nextText: "Sig&#x3e;",
    currentText: "Hoy",
    monthNames: [
      "Enero",
      "Febrero",
      "Marzo",
      "Abril",
      "Mayo",
      "Junio",
      "Julio",
      "Agosto",
      "Septiembre",
      "Octubre",
      "Noviembre",
      "Diciembre"
    ],
    monthNamesShort: [
      "Ene",
      "Feb",
      "Mar",
      "Abr",
      "May",
      "Jun",
      "Jul",
      "Ago",
      "Sep",
      "Oct",
      "Nov",
      "Dic"
    ],
    dayNames: [
      "Domingo",
      "Lunes",
      "Martes",
      "Mi&eacute;rcoles",
      "Jueves",
      "Viernes",
      "S&aacute;bado"
    ],
    dayNamesShort: [
      "Dom",
      "Lun",
      "Mar",
      "Mi&eacute;",
      "Juv",
      "Vie",
      "S&aacute;b"
    ],
    dayNamesMin: ["Do", "Lu", "Ma", "Mi", "Ju", "Vi", "S&aacute;"],
    weekHeader: "Sm",
    dateFormat: "dd/mm/yyyy",
    firstDay: 0,
    isRTL: !1,
    showMonthAfterYear: !1,
    yearSuffix: "",
    yearMask: "aaaa"
  },
  "fr-CA": {
    closeText: "Fermer",
    prevText: "Pr&eacute;c",
    nextText: "Suiv",
    currentText: "Aujourd'hui",
    monthNames: [
      "Janvier ",
      "F&eacute;vrier",
      "Mars",
      "Avril",
      "Mai",
      "Juin",
      "Juillet",
      "Ao&ucirc;t",
      "Septembre",
      "Octobre",
      "Novembre",
      "D&eacute;cembre"
    ],
    monthNamesShort: [
      "Jan",
      "F&eacute;v",
      "Mar",
      "Avr",
      "Mai",
      "Jui",
      "Jui",
      "Ao&ucirc;",
      "Sep",
      "Oct",
      "Nov",
      "D&eacute;c"
    ],
    dayNames: [
      "Dimanche",
      "Lundi",
      "Mardi",
      "Mercredi",
      "Jeudi",
      "Vendredi",
      "Samedi"
    ],
    dayNamesShort: ["Dim", "Lun", "Mar", "Mer", "Jeu", "Ven", "Sam"],
    dayNamesMin: ["Di", "Lu", "Ma", "Me", "Je", "Ve", "Sa"],
    weekHeader: "Wk",
    dateFormat: "dd/mm/yyyy",
    firstDay: 1,
    isRTL: !1,
    showMonthAfterYear: !1,
    yearSuffix: "",
    dayMask: "jj",
    yearMask: "aaaa"
  },
  "pt-BR": {
    closeText: "Fechar",
    prevText: "Anterior",
    nextText: "Avan&ccedil;ar",
    currentText: "Hoje",
    monthNames: [
      "Janeiro",
      "Fevereiro",
      "Mar&ccedil;o",
      "Abril",
      "Maio",
      "Junho",
      "Julho",
      "Agosto",
      "Setembro",
      "Outubro",
      "Novembro",
      "Dezembro"
    ],
    monthNamesShort: [
      "Jan",
      "Fev",
      "Mar",
      "Abr",
      "Mai",
      "Jun",
      "Jul",
      "Ago",
      "Set",
      "Out",
      "Nov",
      "Dez"
    ],
    dayNames: [
      "Domingo",
      "Segunda",
      "Terça",
      "Quarta",
      "Quinta",
      "Sexta",
      "Sábado"
    ],
    dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sáb"],
    dayNamesMin: ["D", "S", "T", "Q", "Q", "S", "S"],
    weekHeader: "Sm",
    dateFormat: "dd/mm/yyyy",
    firstDay: 0,
    isRTL: !1,
    showMonthAfterYear: !1,
    yearSuffix: "",
    yearMask: "aaaa"
  },
  "en-CA": {
    closeText: "Close",
    prevText: "Prev",
    nextText: "Next",
    currentText: "Today",
    monthNames: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December"
    ],
    monthNamesShort: [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ],
    dayNames: [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday"
    ],
    dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
    dayNamesMin: ["S", "M", "T", "W", "T", "F", "S"],
    weekHeader: "Wk",
    dateFormat: "dd/mm/yyyy",
    firstDay: 1,
    isRTL: !1,
    showMonthAfterYear: !1,
    yearSuffix: ""
  }
}, Mi = () => {
  const e = { ...Ee };
  return e.esUS = Ee.es, e.en = Ee.enUS, Object.keys(ce).forEach((t) => {
    const i = t.replace("-", "");
    if (e[i])
      e[i] = {
        ...e[i],
        options: {
          ...e[i].options,
          weekStartsOn: ce[t].firstDay,
          dateFormat: ce[t].dateFormat,
          yearMask: ce[t].yearMask,
          dayMask: ce[t].dayMask
        }
      };
    else
      return;
  }), e;
}, _ = Mi(), $i = (e) => {
  class t extends e {
    constructor(...o) {
      super(...o), this.fontLink = "https://www.aa.com/fonts/css?family=american-sans-variable";
      const r = document.head || document.getElementsByTagName("head")[0];
      if (Array.from(r.getElementsByTagName("link")).findIndex(
        (s) => s.href === this.fontLink
      ) === -1) {
        const s = document.createElement("link");
        s.href = this.fontLink, s.rel = "stylesheet", document.head.appendChild(s);
      }
    }
  }
  return t;
}, Li = '*,:before,:after{box-sizing:border-box;border-width:0;border-style:solid;border-color:currentColor}:before,:after{--tw-content: ""}html,:host{line-height:1.5;-webkit-text-size-adjust:100%;-moz-tab-size:4;-o-tab-size:4;tab-size:4;font-family:AmericanSans Var,Helvetica,Arial,sans-serif;font-feature-settings:normal;font-variation-settings:normal;-webkit-tap-highlight-color:transparent}body{margin:0;line-height:inherit}hr{height:0;color:inherit;border-top-width:1px}abbr:where([title]){-webkit-text-decoration:underline dotted;text-decoration:underline dotted}h1,h2,h3,h4,h5,h6{font-size:inherit;font-weight:inherit}a{color:inherit;text-decoration:inherit}b,strong{font-weight:bolder}code,kbd,samp,pre{font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-feature-settings:normal;font-variation-settings:normal;font-size:1em}small{font-size:80%}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}table{text-indent:0;border-color:inherit;border-collapse:collapse}button,input,optgroup,select,textarea{font-family:inherit;font-feature-settings:inherit;font-variation-settings:inherit;font-size:100%;font-weight:inherit;line-height:inherit;letter-spacing:inherit;color:inherit;margin:0;padding:0}button,select{text-transform:none}button,input:where([type=button]),input:where([type=reset]),input:where([type=submit]){-webkit-appearance:button;background-color:transparent;background-image:none}:-moz-focusring{outline:auto}:-moz-ui-invalid{box-shadow:none}progress{vertical-align:baseline}::-webkit-inner-spin-button,::-webkit-outer-spin-button{height:auto}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}::-webkit-search-decoration{-webkit-appearance:none}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}summary{display:list-item}blockquote,dl,dd,h1,h2,h3,h4,h5,h6,hr,figure,p,pre{margin:0}fieldset{margin:0;padding:0}legend{padding:0}ol,ul,menu{list-style:none;margin:0;padding:0}dialog{padding:0}textarea{resize:vertical}input::-moz-placeholder,textarea::-moz-placeholder{opacity:1;color:#9ca3af}input::placeholder,textarea::placeholder{opacity:1;color:#9ca3af}button,[role=button]{cursor:pointer}:disabled{cursor:default}img,svg,video,canvas,audio,iframe,embed,object{display:block;vertical-align:middle}img,video{max-width:100%;height:auto}[hidden]{display:none}strong{font-weight:700;font-variation-settings:"wght" 700}*,:before,:after{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }::backdrop{--tw-border-spacing-x: 0;--tw-border-spacing-y: 0;--tw-translate-x: 0;--tw-translate-y: 0;--tw-rotate: 0;--tw-skew-x: 0;--tw-skew-y: 0;--tw-scale-x: 1;--tw-scale-y: 1;--tw-pan-x: ;--tw-pan-y: ;--tw-pinch-zoom: ;--tw-scroll-snap-strictness: proximity;--tw-gradient-from-position: ;--tw-gradient-via-position: ;--tw-gradient-to-position: ;--tw-ordinal: ;--tw-slashed-zero: ;--tw-numeric-figure: ;--tw-numeric-spacing: ;--tw-numeric-fraction: ;--tw-ring-inset: ;--tw-ring-offset-width: 0px;--tw-ring-offset-color: #fff;--tw-ring-color: rgb(59 130 246 / .5);--tw-ring-offset-shadow: 0 0 #0000;--tw-ring-shadow: 0 0 #0000;--tw-shadow: 0 0 #0000;--tw-shadow-colored: 0 0 #0000;--tw-blur: ;--tw-brightness: ;--tw-contrast: ;--tw-grayscale: ;--tw-hue-rotate: ;--tw-invert: ;--tw-saturate: ;--tw-sepia: ;--tw-drop-shadow: ;--tw-backdrop-blur: ;--tw-backdrop-brightness: ;--tw-backdrop-contrast: ;--tw-backdrop-grayscale: ;--tw-backdrop-hue-rotate: ;--tw-backdrop-invert: ;--tw-backdrop-opacity: ;--tw-backdrop-saturate: ;--tw-backdrop-sepia: ;--tw-contain-size: ;--tw-contain-layout: ;--tw-contain-paint: ;--tw-contain-style: }.container{width:100%}@media (min-width: 24.375rem){.container{max-width:24.375rem}}@media (min-width: 50rem){.container{max-width:50rem}}@media (min-width: 80rem){.container{max-width:80rem}}@media (min-width: 90rem){.container{max-width:90rem}}.sr-only{position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border-width:0}.pointer-events-none{pointer-events:none}.pointer-events-auto{pointer-events:auto}.visible{visibility:visible}.invisible{visibility:hidden}.static{position:static}.fixed{position:fixed}.absolute{position:absolute}.relative{position:relative}.inset-0{top:0;right:0;bottom:0;left:0}.bottom-\\[7px\\]{bottom:7px}.left-0{left:0}.right-4{right:1rem}.top-0{top:0}.top-16{top:4rem}.top-4{top:1rem}.z-0{z-index:0}.z-10{z-index:10}.z-50{z-index:50}.col-span-7{grid-column:span 7 / span 7}.m-0{margin:0}.m-0\\.5{margin:.125rem}.mx-1{margin-left:.25rem;margin-right:.25rem}.my-6{margin-top:1.5rem;margin-bottom:1.5rem}.-mt-1{margin-top:-.25rem}.-mt-px{margin-top:-1px}.mb-2{margin-bottom:.5rem}.ml-1{margin-left:.25rem}.mr-1{margin-right:.25rem}.mr-4{margin-right:1rem}.mt-2{margin-top:.5rem}.mt-5{margin-top:1.25rem}.mt-7{margin-top:1.75rem}.mt-\\[60px\\]{margin-top:60px}.box-border{box-sizing:border-box}.block{display:block}.inline{display:inline}.flex{display:flex}.inline-flex{display:inline-flex}.table{display:table}.grid{display:grid}.hidden{display:none}.aspect-square{aspect-ratio:1 / 1}.h-1\\.5{height:.375rem}.h-12{height:3rem}.h-14{height:3.5rem}.h-9{height:2.25rem}.h-\\[349px\\]{height:349px}.h-full{height:100%}.max-h-\\[calc\\(100vh-2rem\\)\\]{max-height:calc(100vh - 2rem)}.min-h-\\[300px\\]{min-height:300px}.w-1\\.5{width:.375rem}.w-12{width:3rem}.w-9{width:2.25rem}.w-\\[704px\\]{width:704px}.w-auto{width:auto}.w-full{width:100%}.w-px{width:1px}.min-w-\\[1120px\\]{min-width:1120px}.min-w-\\[296px\\]{min-width:296px}.min-w-\\[348px\\]{min-width:348px}.min-w-\\[704px\\]{min-width:704px}.max-w-\\[377px\\]{max-width:377px}.max-w-\\[406px\\]{max-width:406px}.max-w-\\[762px\\]{max-width:762px}.max-w-\\[calc\\(100vw-2rem\\)\\]{max-width:calc(100vw - 2rem)}.flex-auto{flex:1 1 auto}.flex-initial{flex:0 1 auto}.translate-x-0{--tw-translate-x: 0px;transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.transform{transform:translate(var(--tw-translate-x),var(--tw-translate-y)) rotate(var(--tw-rotate)) skew(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y))}.transform-none{transform:none}.cursor-default{cursor:default}.cursor-pointer{cursor:pointer}.resize{resize:both}.appearance-none{-webkit-appearance:none;-moz-appearance:none;appearance:none}.grid-flow-row{grid-auto-flow:row}.grid-flow-col{grid-auto-flow:column}.grid-cols-7{grid-template-columns:repeat(7,minmax(0,1fr))}.flex-col{flex-direction:column}.flex-nowrap{flex-wrap:nowrap}.items-center{align-items:center}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-between{justify-content:space-between}.justify-items-center{justify-items:center}.gap-1{gap:.25rem}.gap-1\\.5{gap:.375rem}.gap-2{gap:.5rem}.gap-3{gap:.75rem}.overflow-auto{overflow:auto}.overflow-hidden{overflow:hidden}.overflow-visible{overflow:visible}.whitespace-nowrap{white-space:nowrap}.break-all{word-break:break-all}.rounded{border-radius:.25rem}.rounded-lg{border-radius:.5rem}.border{border-width:1px}.border-b{border-bottom-width:1px}.border-b-4{border-bottom-width:4px}.border-solid{border-style:solid}.border-\\[\\#637E9C\\]{border-color:#637e9c}.border-blue-060{border-color:#0860c4}.border-blue-070{border-color:#0a78f5}.border-blue-080{border-color:#3b93f7}.border-neutral-050{border-color:#405164}.border-neutral-070{border-color:#637e9c}.border-neutral-090{border-color:#b4c1cf}.border-neutral-100{border-color:#e6eaef}.border-red-070{border-color:#e33b4e}.border-transparent{border-color:transparent}.bg-\\[rgba\\(0\\,0\\,0\\,0\\.8\\)\\]{background-color:#000c}.bg-blue-060{background-color:#0860c4}.bg-blue-070{background-color:#0a78f5}.bg-blue-080{background-color:#3b93f7}.bg-blue-100{background-color:#d8e9fd}.bg-blue-110{background-color:#e2effe}.bg-blue-120{background-color:#ecf4fe}.bg-neutral-000{background-color:#101419}.bg-neutral-010{background-color:#181e25}.bg-neutral-020{background-color:#202832}.bg-neutral-030{background-color:#28323e}.bg-neutral-040{background-color:#303d4b}.bg-neutral-050{background-color:#405164}.bg-neutral-090{background-color:#b4c1cf}.bg-neutral-100{background-color:#e6eaef}.bg-neutral-110{background-color:#eceff3}.bg-neutral-120{background-color:#f3f5f7}.bg-neutral-130{background-color:#f9fafb}.bg-neutral-140{background-color:#fff}.bg-red-070{background-color:#e33b4e}.bg-transparent{background-color:transparent}.p-0{padding:0}.p-0\\.5{padding:.125rem}.p-2{padding:.5rem}.px-3{padding-left:.75rem;padding-right:.75rem}.px-4{padding-left:1rem;padding-right:1rem}.px-5{padding-left:1.25rem;padding-right:1.25rem}.px-6{padding-left:1.5rem;padding-right:1.5rem}.py-3{padding-top:.75rem;padding-bottom:.75rem}.py-6{padding-top:1.5rem;padding-bottom:1.5rem}.pb-2{padding-bottom:.5rem}.pb-6{padding-bottom:1.5rem}.pl-12{padding-left:3rem}.pl-2{padding-left:.5rem}.pl-3{padding-left:.75rem}.pl-4{padding-left:1rem}.pr-12{padding-right:3rem}.pr-2{padding-right:.5rem}.pr-24{padding-right:6rem}.pr-3{padding-right:.75rem}.pr-4{padding-right:1rem}.pt-3{padding-top:.75rem}.pt-6{padding-top:1.5rem}.text-left{text-align:left}.text-center{text-align:center}.font-sans{font-family:AmericanSans Var,Helvetica,Arial,sans-serif}.text-\\[12px\\]{font-size:12px}.text-\\[14px\\]{font-size:14px}.text-base{font-size:1rem}.text-lg{font-size:1.25rem}.text-sm{font-size:.875rem}.text-xs{font-size:.75rem}.capitalize{text-transform:capitalize}.leading-4{line-height:1rem}.leading-5{line-height:1.25rem}.leading-6{line-height:1.5rem}.leading-7{line-height:1.75rem}.text-blue-060{color:#0860c4}.text-blue-080{color:#3b93f7}.text-green-060{color:#316833}.text-neutral-000{color:#101419}.text-neutral-010{color:#181e25}.text-neutral-050{color:#405164}.text-neutral-060{color:#50657c}.text-neutral-090{color:#b4c1cf}.text-neutral-130{color:#f9fafb}.text-neutral-140{color:#fff}.text-red-060{color:#cd1d32}.text-red-070{color:#e33b4e}.underline{text-decoration-line:underline}.placeholder-neutral-060::-moz-placeholder{--tw-placeholder-opacity: 1;color:rgb(80 101 124 / var(--tw-placeholder-opacity))}.placeholder-neutral-060::placeholder{--tw-placeholder-opacity: 1;color:rgb(80 101 124 / var(--tw-placeholder-opacity))}.opacity-100{opacity:1}.shadow-xl{--tw-shadow: 0px 9px 46px 8px rgba(0, 0, 0, .12), 0px 24px 38px 3px rgba(0, 0, 0, .14), 0px 11px 15px -7px rgba(0, 0, 0, .2);--tw-shadow-colored: 0px 9px 46px 8px var(--tw-shadow-color), 0px 24px 38px 3px var(--tw-shadow-color), 0px 11px 15px -7px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}.outline{outline-style:solid}.outline-2{outline-width:2px}.outline-offset-2{outline-offset:2px}.outline-blue-070{outline-color:#0a78f5}.outline-neutral-100{outline-color:#e6eaef}.blur{--tw-blur: blur(8px);filter:var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow)}.transition{transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,-webkit-backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke,opacity,box-shadow,transform,filter,backdrop-filter,-webkit-backdrop-filter;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.transition-transform{transition-property:transform;transition-timing-function:cubic-bezier(.4,0,.2,1);transition-duration:.15s}.duration-200{transition-duration:.2s}.content-none{--tw-content: none;content:var(--tw-content)}.font-\\[400\\]{font-weight:400;font-variation-settings:"wght" 400}.font-bold{font-weight:700;font-variation-settings:"wght" 700}.font-medium{font-weight:500;font-variation-settings:"wght" 500}.font-normal{font-weight:400;font-variation-settings:"wght" 400}[hidden]{display:none!important}.after\\:pointer-events-none:after{content:var(--tw-content);pointer-events:none}.after\\:absolute:after{content:var(--tw-content);position:absolute}.after\\:left-0:after{content:var(--tw-content);left:0}.after\\:top-0:after{content:var(--tw-content);top:0}.after\\:ml-1:after{content:var(--tw-content);margin-left:.25rem}.after\\:box-border:after{content:var(--tw-content);box-sizing:border-box}.after\\:h-1:after{content:var(--tw-content);height:.25rem}.after\\:h-1\\.5:after{content:var(--tw-content);height:.375rem}.after\\:h-full:after{content:var(--tw-content);height:100%}.after\\:w-1:after{content:var(--tw-content);width:.25rem}.after\\:w-1\\.5:after{content:var(--tw-content);width:.375rem}.after\\:w-full:after{content:var(--tw-content);width:100%}.after\\:rounded-lg:after{content:var(--tw-content);border-radius:.5rem}.after\\:border:after{content:var(--tw-content);border-width:1px}.after\\:border-solid:after{content:var(--tw-content);border-style:solid}.after\\:border-transparent:after{content:var(--tw-content);border-color:transparent}.after\\:bg-red-070:after{content:var(--tw-content);background-color:#e33b4e}.first\\:pr-2:first-child{padding-right:.5rem}.last\\:right-1:last-child{right:.25rem}.hover\\:border-blue-070:hover{border-color:#0a78f5}.hover\\:border-neutral-100:hover{border-color:#e6eaef}.hover\\:bg-blue-070:hover{background-color:#0a78f5}.hover\\:bg-blue-110:hover{background-color:#e2effe}.hover\\:bg-blue-120:hover{background-color:#ecf4fe}.hover\\:bg-neutral-100:hover{background-color:#e6eaef}.hover\\:bg-neutral-110:hover{background-color:#eceff3}.hover\\:bg-neutral-120:hover{background-color:#f3f5f7}.hover\\:bg-neutral-130:hover{background-color:#f9fafb}.hover\\:bg-transparent:hover{background-color:transparent}.hover\\:text-blue-060:hover{color:#0860c4}.focus\\:border-blue-070:focus{border-color:#0a78f5}.focus\\:bg-neutral-140:focus{background-color:#fff}.focus\\:outline:focus{outline-style:solid}.focus\\:outline-0:focus{outline-width:0px}.focus\\:outline-2:focus{outline-width:2px}.focus\\:outline-offset-2:focus{outline-offset:2px}.focus\\:outline-blue-070:focus{outline-color:#0a78f5}.focus\\:outline-neutral-100:focus{outline-color:#e6eaef}.active\\:border-blue-080:active{border-color:#3b93f7}.active\\:border-neutral-070:active{border-color:#637e9c}.active\\:border-neutral-100:active{border-color:#e6eaef}.active\\:bg-blue-080:active{background-color:#3b93f7}.active\\:bg-blue-100:active{background-color:#d8e9fd}.active\\:bg-neutral-100:active{background-color:#e6eaef}.active\\:bg-neutral-110:active{background-color:#eceff3}.active\\:bg-neutral-120:active{background-color:#f3f5f7}.active\\:bg-neutral-130:active{background-color:#f9fafb}.active\\:bg-transparent:active{background-color:transparent}.active\\:text-blue-060:active{color:#0860c4}.active\\:outline:active{outline-style:solid}.active\\:outline-2:active{outline-width:2px}.active\\:outline-offset-2:active{outline-offset:2px}.active\\:outline-blue-070:active{outline-color:#0a78f5}.active\\:outline-neutral-100:active{outline-color:#e6eaef}.disabled\\:pointer-events-none:disabled{pointer-events:none}.disabled\\:cursor-default:disabled{cursor:default}.disabled\\:border-neutral-090:disabled{border-color:#b4c1cf}.disabled\\:bg-neutral-090:disabled{background-color:#b4c1cf}.disabled\\:bg-neutral-120:disabled{background-color:#f3f5f7}.disabled\\:text-neutral-090:disabled{color:#b4c1cf}.dark\\:border-blue-080:is(:host([aileron-color-scheme=dark]) *){border-color:#3b93f7}.dark\\:border-neutral-050:is(:host([aileron-color-scheme=dark]) *){border-color:#405164}.dark\\:border-neutral-070:is(:host([aileron-color-scheme=dark]) *){border-color:#637e9c}.dark\\:border-neutral-100:is(:host([aileron-color-scheme=dark]) *){border-color:#e6eaef}.dark\\:bg-blue-080:is(:host([aileron-color-scheme=dark]) *){background-color:#3b93f7}.dark\\:bg-neutral-000:is(:host([aileron-color-scheme=dark]) *){background-color:#101419}.dark\\:bg-neutral-020:is(:host([aileron-color-scheme=dark]) *){background-color:#202832}.dark\\:bg-neutral-050:is(:host([aileron-color-scheme=dark]) *){background-color:#405164}.dark\\:bg-transparent:is(:host([aileron-color-scheme=dark]) *){background-color:transparent}.dark\\:text-blue-080:is(:host([aileron-color-scheme=dark]) *){color:#3b93f7}.dark\\:text-neutral-000:is(:host([aileron-color-scheme=dark]) *){color:#101419}.dark\\:text-neutral-050:is(:host([aileron-color-scheme=dark]) *){color:#405164}.dark\\:text-neutral-080:is(:host([aileron-color-scheme=dark]) *){color:#8398af}.dark\\:text-neutral-130:is(:host([aileron-color-scheme=dark]) *){color:#f9fafb}.dark\\:text-neutral-140:is(:host([aileron-color-scheme=dark]) *){color:#fff}.dark\\:text-red-080:is(:host([aileron-color-scheme=dark]) *){color:#e96776}.dark\\:placeholder-neutral-080:is(:host([aileron-color-scheme=dark]) *)::-moz-placeholder{--tw-placeholder-opacity: 1;color:rgb(131 152 175 / var(--tw-placeholder-opacity))}.dark\\:placeholder-neutral-080:is(:host([aileron-color-scheme=dark]) *)::placeholder{--tw-placeholder-opacity: 1;color:rgb(131 152 175 / var(--tw-placeholder-opacity))}.dark\\:shadow-\\[0_9px_46px_8px_rgba\\(0\\,0\\,0\\,1\\)\\,0_24px_38px_3px_rgba\\(0\\,0\\,0\\,1\\)\\,0_11px_15px_-7px\\,rgba\\(0\\,0\\,0\\,1\\)\\]:is(:host([aileron-color-scheme=dark]) *){--tw-shadow-color: 0 9px 46px 8px rgba(0,0,0,1),0 24px 38px 3px rgba(0,0,0,1),0 11px 15px -7px,rgba(0,0,0,1);--tw-shadow: var(--tw-shadow-colored)}.dark\\:hover\\:bg-blue-070:hover:is(:host([aileron-color-scheme=dark]) *){background-color:#0a78f5}.dark\\:hover\\:bg-neutral-010:hover:is(:host([aileron-color-scheme=dark]) *){background-color:#181e25}.dark\\:hover\\:bg-neutral-020:hover:is(:host([aileron-color-scheme=dark]) *){background-color:#202832}.dark\\:hover\\:bg-neutral-030:hover:is(:host([aileron-color-scheme=dark]) *){background-color:#28323e}.dark\\:hover\\:bg-transparent:hover:is(:host([aileron-color-scheme=dark]) *){background-color:transparent}.dark\\:focus\\:bg-blue-080:focus:is(:host([aileron-color-scheme=dark]) *){background-color:#3b93f7}.dark\\:focus\\:bg-neutral-000:focus:is(:host([aileron-color-scheme=dark]) *){background-color:#101419}.dark\\:active\\:border-blue-060:active:is(:host([aileron-color-scheme=dark]) *){border-color:#0860c4}.dark\\:active\\:border-neutral-100:active:is(:host([aileron-color-scheme=dark]) *){border-color:#e6eaef}.dark\\:active\\:bg-blue-060:active:is(:host([aileron-color-scheme=dark]) *){background-color:#0860c4}.dark\\:active\\:bg-blue-070:active:is(:host([aileron-color-scheme=dark]) *){background-color:#0a78f5}.dark\\:active\\:bg-neutral-010:active:is(:host([aileron-color-scheme=dark]) *){background-color:#181e25}.dark\\:active\\:bg-neutral-020:active:is(:host([aileron-color-scheme=dark]) *){background-color:#202832}.dark\\:active\\:bg-neutral-030:active:is(:host([aileron-color-scheme=dark]) *){background-color:#28323e}.dark\\:active\\:bg-neutral-040:active:is(:host([aileron-color-scheme=dark]) *){background-color:#303d4b}.dark\\:active\\:bg-transparent:active:is(:host([aileron-color-scheme=dark]) *){background-color:transparent}.dark\\:disabled\\:border-neutral-050:disabled:is(:host([aileron-color-scheme=dark]) *){border-color:#405164}.dark\\:disabled\\:bg-neutral-020:disabled:is(:host([aileron-color-scheme=dark]) *){background-color:#202832}.dark\\:disabled\\:bg-neutral-050:disabled:is(:host([aileron-color-scheme=dark]) *){background-color:#405164}.dark\\:disabled\\:bg-transparent:disabled:is(:host([aileron-color-scheme=dark]) *){background-color:transparent}.dark\\:disabled\\:text-neutral-050:disabled:is(:host([aileron-color-scheme=dark]) *){color:#405164}@media (min-width: 50rem){.sm\\:max-h-\\[80vh\\]{max-height:80vh}.sm\\:min-w-\\[356px\\]{min-width:356px}.sm\\:max-w-\\[546px\\]{max-width:546px}.sm\\:max-w-\\[calc\\(100vw-4rem\\)\\]{max-width:calc(100vw - 4rem)}}@media (min-width: 80rem){.md\\:min-w-\\[389px\\]{min-width:389px}.md\\:max-w-\\[596px\\]{max-width:596px}.md\\:max-w-\\[calc\\(100vw-4rem\\)\\]{max-width:calc(100vw - 4rem)}}@media (min-width: 90rem){.lg\\:max-w-\\[1216px\\]{max-width:1216px}}', Ei = Te(Li), ge = "aileron-color-scheme", rt = "aileron-color-scheme-change", Fi = (e) => {
  const i = class i extends e {
    constructor() {
      super(...arguments), this.handleSchemeSwitch = (r) => {
        r.detail ? this.setAttribute(ge, r.detail) : this.removeAttribute(ge);
      };
    }
    /**
     * Init web component with listener for theme changes, and gets current theme state.
     */
    connectedCallback() {
      super.connectedCallback(), document.documentElement.addEventListener(
        rt,
        this.handleSchemeSwitch,
        {
          passive: !0
        }
      );
      const r = document.documentElement.getAttribute(
        ge
      );
      r && this.setAttribute(ge, r);
    }
    disconnectedCallback() {
      super.disconnectedCallback(), document.documentElement.removeEventListener(
        rt,
        this.handleSchemeSwitch
      );
    }
  };
  i.styles = [
    Ei,
    e.styles ?? []
  ];
  let t = i;
  return t;
}, ne = Fi($i(Vt)), We = '.calendar-month{font-weight:700;font-size:16px}:host(.adc-calendar) .calendar__grid-range-hover.calendar__grid-range-enabled .calendar__day--departure-wrapper~.calendar__day--wrapper>.adc-button-icon:not(.hovered-day~*>.adc-button-icon):not(.hovered-day>.adc-button-icon){background-color:#ecf4fe}:host(.adc-calendar) .calendar__grid-range-hover.calendar__grid-range-enabled .calendar__day--after-departure-month-wrapper~.calendar__day--wrapper>.adc-button-icon:not(.hovered-day~*>.adc-button-icon):not(.hovered-day>.adc-button-icon){background-color:#ecf4fe}:host(.adc-calendar) .calendar__grid-range-hover.calendar__grid-range-enabled .calendar__day--after-departure-month-wrapper>.adc-button-icon{background-color:#ecf4fe}:host(.adc-calendar) .adc-button-icon::part(icon){--icon-fill: var(--neutral-000)}:host(.adc-calendar) .adc-button-icon.bg-blue-060::part(icon){--icon-fill: var(--neutral-140)}:host(.adc-calendar) .adc-button-icon[disabled]::part(icon){--icon-fill: var(--neutral-090)}:host(.adc-calendar) .adc-button-icon.calendar__day-show-price::part(button-icon){align-items:flex-start;padding-top:6px}:host(.adc-calendar) .adc-button-icon::part(button-icon){width:inherit;height:inherit;color:inherit;margin-top:0}:host(.adc-calendar) .adc-button-icon.calendar__day--highlight-day::part(button-icon):after{content:"";position:absolute;width:calc(100% - 8px);height:2px;background-color:#e6eaef;bottom:4px}:host(.adc-calendar) .adc-button-icon{-webkit-appearance:none!important;-moz-appearance:none!important;appearance:none!important}:host(.adc-date-picker) #calendarDropdown{--tw-shadow: 0px 1px 18px 0px rgba(0, 0, 0, .12), 0px 6px 10px 0px rgba(0, 0, 0, .14), 0px 3px 5px -1px rgba(0, 0, 0, .2);--tw-shadow-colored: 0px 1px 18px 0px var(--tw-shadow-color), 0px 6px 10px 0px var(--tw-shadow-color), 0px 3px 5px -1px var(--tw-shadow-color);box-shadow:var(--tw-ring-offset-shadow, 0 0 #0000),var(--tw-ring-shadow, 0 0 #0000),var(--tw-shadow)}:host(.adc-calendar) .adc-button-icon:hover::part(button-icon){background:none}:host(.adc-date-picker) .adc-tooltip{z-index:1}:host(.adc-date-picker) .adc-dialog[variant=message]::part(panel){max-width:802px;max-height:80vh}:host(.adc-date-picker) .adc-dialog[variant=fullscreen]::part(panel){width:100%}:host(.adc-date-picker) .adc-dialog::part(body){padding-left:20px;padding-right:20px;margin-bottom:20px}@media (max-width: 406px){:host(.adc-date-picker) .adc-dialog::part(body){padding-left:12px;padding-right:12px}}:host(.adc-date-picker) .adc-dialog::part(footer){padding-left:20px;padding-right:20px}:host(.adc-date-picker) .adc-dialog .adc-tabs{margin-left:-20px;margin-right:-20px}@media (max-width: 406px){:host(.adc-date-picker) .adc-dialog .adc-tabs{margin-left:-12px;margin-right:-12px}}:host(.adc-date-picker) .adc-text-input.modify-selection-highlight::part(input){border-color:#0a78f5;box-shadow:0 0 0 1px var(--blue-070)}:host(.adc-date-picker[input-kind="button"]) .adc-text-input:hover::part(input){cursor:pointer}:host(.adc-date-picker[input-kind="button"]) .adc-text-input::part(input){text-align:left}:host(.adc-date-picker) .adc-text-input{min-width:158px}:host(.adc-calendar-navigation) .adc-button-icon[disabled]::part(icon){--icon-fill: var(--neutral-090)}';
var _i = Object.defineProperty, Ai = Object.getOwnPropertyDescriptor, je = (e, t, i, o) => {
  for (var r = o > 1 ? void 0 : o ? Ai(t, i) : t, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (r = (o ? n(t, i, r) : n(r)) || r);
  return o && r && _i(t, i, r), r;
};
const Je = class Je extends ne {
  constructor(t) {
    super(), this.disabled = !1, this.customElementString = t;
  }
  async connectedCallback() {
    super.connectedCallback(), this.classList.add("adc-calendar-navigation"), Re(
      this.customElementString ? this.customElementString + "-calendar-navigation" : "adc-calendar-navigation"
    );
  }
  clickHandler() {
    N(this, "adc-click");
  }
  createTagName(t) {
    return ze(
      this.customElementString ? this.customElementString + t : "adc" + t
    );
  }
  render() {
    return E`
      <${this.createTagName("-calendar-navigation-button-icon")}
        icon=${this.icon}
        size="md"
        outlined
        class="calendar__button"
        type="button"
        kind="ghost"
        @click=${this.clickHandler}
        ?disabled=${this.disabled}
      >
        <slot>${this.labelText}</slot>
      </${this.createTagName("-calendar-navigation-button-icon")}>
    `;
  }
};
Je.styles = [ne.styles || [], Te(We)];
let Q = Je;
je([
  y({ attribute: "label-text" })
], Q.prototype, "labelText", 2);
je([
  y({ type: Boolean })
], Q.prototype, "disabled", 2);
je([
  y()
], Q.prototype, "icon", 2);
try {
  customElements.define("adc-calendar-navigation", Q);
} catch {
}
function Mt(e) {
  try {
    customElements.define(
      `${e}-calendar-navigation`,
      class extends Q {
        constructor() {
          super(e);
        }
      }
    );
  } catch {
  }
}
const Oi = (e, t) => {
  const i = oe(e, f(t.firstSelection)), o = oe(e, f(t.secondSelection)), r = ut(e), a = e.toLocaleString(t.locale, {
    weekday: "long",
    month: "long",
    day: "numeric",
    year: "numeric"
  });
  return `${r ? "Today's date, " : ""}${i ? "Selected departure date, " : ""} ${o ? "Selected arrival date, " : ""} ${a}, ${(() => {
    const l = "click to set departure", d = "click to set arrival";
    return t.modifyFirstSelection || t.modifyFirstSelection ? l : t.manualSelection && !t.modifyFirstSelection ? d : t.firstSelection && A(e, f(t.firstSelection)) ? l : d;
  })()}`;
}, Ni = ({
  date: e,
  days: t,
  state: i,
  daysInMonth: o
}) => {
  [...Array(o)].forEach((r, a) => {
    const n = new Date(e.getTime());
    n.setDate(a + 1);
    const s = Oi(n, i);
    t.push({
      date: n.toISOString(),
      value: n.getDate(),
      screenReader: s,
      weekday: n.getDay(),
      isToday: ut(n),
      isDeparture: oe(n, f(i.firstSelection)),
      isArrival: oe(n, f(i.secondSelection)),
      isInRange: !!i.firstSelection && !!i.secondSelection && !A(n, f(i.firstSelection)) && A(n, f(i.secondSelection))
    });
  });
}, Fe = ({
  newMonth: e,
  state: t
}) => {
  const i = new Date(e), o = new Date(i.getFullYear(), i.getMonth() + 1, 0), r = i.getMonth(), a = o.getDate(), n = parseInt(
    ht(i, "e", { locale: _[t.dateFnsLocale] }),
    10
  ), s = o.getDay(), l = [];
  return Ni({ date: i, days: l, state: t, daysInMonth: a }), {
    id: Bt(),
    name: i.toISOString(),
    value: r,
    firstDayOfMonth: n,
    lastDayOfMonth: s,
    days: l
  };
}, Ri = {
  currentDate: (/* @__PURE__ */ new Date()).toISOString(),
  month: [],
  firstSelection: "",
  secondSelection: "",
  modifyFirstSelection: !0,
  showMultipleMonths: !0,
  manualSelection: !0,
  locale: "en-US",
  dateFnsLocale: "enUS"
}, v = It({
  name: "calendar",
  initialState: Ri,
  reducers: {
    setCurrentDate(e, t) {
      e.currentDate = t.payload;
    },
    setState(e, t) {
      const { name: i, value: o } = t.payload;
      if (e[i] = o, i === "modifyFirstSelection" && e.month.length > 0) {
        const r = e.month[1].days[0].date;
        v.caseReducers.buildCalendar(e, {
          payload: {
            date: r || e.currentDate
          },
          type: "calendar/buildCalendar"
        });
      }
      i === "locale" && v.caseReducers.refreshCalendar(e);
    },
    setShowMultipleMonths(e, t) {
      e.showMultipleMonths = t.payload;
    },
    jumpToDate(e, t) {
      const i = e.month[1].days[0].date, { modifyFirstSelection: o, minDateString: r } = t.payload;
      if (e.modifyFirstSelection = o, !!i) {
        if (!e.firstSelection && !e.secondSelection && !de(
          f(e.currentDate),
          f(i)
        )) {
          v.caseReducers.clearCalendar(e), v.caseReducers.buildCalendar(e, {
            payload: {
              date: r || e.currentDate
            },
            type: "calendar/buildCalendar"
          });
          return;
        }
        if (!e.firstSelection && e.secondSelection) {
          if (!de(
            f(e.secondSelection),
            f(i)
          )) {
            v.caseReducers.clearCalendar(e), v.caseReducers.buildCalendar(e, {
              payload: {
                date: e.secondSelection
              },
              type: "calendar/buildCalendar"
            });
            return;
          }
        } else if (e.firstSelection && !e.secondSelection && !de(
          f(e.firstSelection),
          f(i)
        )) {
          v.caseReducers.clearCalendar(e), v.caseReducers.buildCalendar(e, {
            payload: {
              date: e.firstSelection
            },
            type: "calendar/buildCalendar"
          });
          return;
        }
        if (e.firstSelection && e.secondSelection && de(
          f(e.firstSelection),
          f(e.secondSelection)
        )) {
          v.caseReducers.clearCalendar(e), v.caseReducers.buildCalendar(e, {
            payload: {
              date: e.firstSelection
            },
            type: "calendar/buildCalendar"
          });
          return;
        }
        if (o)
          e.firstSelection && (f(e.firstSelection).getMonth() !== f(i).getMonth() || f(e.firstSelection).getFullYear() !== f(i).getFullYear()) && (v.caseReducers.clearCalendar(e), v.caseReducers.buildCalendar(e, {
            payload: {
              date: e.firstSelection || e.currentDate
            },
            type: "calendar/buildCalendar"
          }));
        else if (e.secondSelection)
          if (e.showMultipleMonths) {
            if (f(e.secondSelection).getMonth() !== f(i).getMonth() + 1 || f(e.secondSelection).getFullYear() !== f(i).getFullYear()) {
              v.caseReducers.clearCalendar(e);
              const a = f(
                e.secondSelection
              );
              a.setMonth(
                f(e.secondSelection).getMonth() + -1,
                1
              ), v.caseReducers.buildCalendar(e, {
                payload: {
                  date: a.toISOString()
                },
                type: "calendar/buildCalendar"
              });
            }
          } else
            (f(e.secondSelection).getMonth() !== f(i).getMonth() || f(e.secondSelection).getFullYear() !== f(i).getFullYear()) && (v.caseReducers.clearCalendar(e), v.caseReducers.buildCalendar(e, {
              payload: {
                date: e.secondSelection
              },
              type: "calendar/buildCalendar"
            }));
      }
    },
    clearCalendar(e) {
      e.month = [];
    },
    clearDates(e) {
      const t = e.month[1].days[0].date;
      e.firstSelection = "", e.secondSelection = "", e.modifyFirstSelection = !0, v.caseReducers.clearCalendar(e), v.caseReducers.buildCalendar(e, {
        payload: {
          date: t || e.currentDate
        },
        type: "calendar/buildCalendar"
      });
    },
    setFirstSelectionOnly(e, t) {
      e.firstSelection = t.payload, v.caseReducers.refreshCalendar(e);
    },
    setSecondSelectionOnly(e, t) {
      e.secondSelection = t.payload, v.caseReducers.refreshCalendar(e);
    },
    setFirstSelection(e, t) {
      const { firstSelection: i, manualSelection: o } = t.payload;
      e.firstSelection = i, o ? e.secondSelection && Ie(
        f(e.firstSelection),
        f(e.secondSelection)
      ) && (e.secondSelection = "") : (e.secondSelection = "", e.modifyFirstSelection = !1);
      const r = e.month[1].days[0].date;
      v.caseReducers.clearCalendar(e), v.caseReducers.buildCalendar(e, {
        payload: {
          date: r || e.currentDate
        },
        type: "calendar/buildCalendar"
      });
    },
    setSecondSelection(e, t) {
      const { secondSelection: i, manualSelection: o } = t.payload;
      e.secondSelection = i;
      const r = e.month[1].days[0].date;
      o || (e.modifyFirstSelection = !0), v.caseReducers.clearCalendar(e), v.caseReducers.buildCalendar(e, {
        payload: {
          date: r || e.currentDate
        },
        type: "calendar/buildCalendar"
      });
    },
    buildCalendar(e, t) {
      v.caseReducers.clearCalendar(e);
      const i = e.showMultipleMonths ? 3 : 2, o = f(t.payload.date);
      for (let r = -1; r < i; r++) {
        const a = new Date(o.getTime());
        a.setMonth(a.getMonth() + r, 1);
        const n = Fe({ newMonth: a, state: e });
        e.month.push(n);
      }
    },
    incrementMonth(e) {
      e.month.shift();
      const t = e.month[e.month.length - 1], i = new Date(
        f(t.days[0].date).getTime()
      );
      i.setMonth(i.getMonth() + 1, 1);
      const o = Fe({ newMonth: i, state: e });
      e.month.push(o);
    },
    decrementMonth(e) {
      e.month.pop();
      const t = e.month[0], i = new Date(
        f(t.days[0].date).getTime()
      );
      i.setMonth(i.getMonth() - 1, 1);
      const o = Fe({ newMonth: i, state: e });
      e.month.unshift(o);
    },
    refreshCalendar(e) {
      const t = e.month[1].days[0].date;
      v.caseReducers.clearCalendar(e), v.caseReducers.buildCalendar(e, {
        payload: {
          date: t || e.currentDate
        },
        type: "calendar/buildCalendar"
      });
    }
  }
}), {
  setCurrentDate: xo,
  incrementMonth: Ii,
  decrementMonth: zi,
  buildCalendar: Pi,
  setSecondSelection: nt,
  setFirstSelection: be,
  clearCalendar: Vi,
  jumpToDate: Bi,
  clearDates: Wi,
  setShowMultipleMonths: ji,
  setState: P,
  setFirstSelectionOnly: W,
  setSecondSelectionOnly: j,
  refreshCalendar: So
} = v.actions, $t = v.reducer;
var Ji = Object.defineProperty, Yi = Object.getOwnPropertyDescriptor, D = (e, t, i, o) => {
  for (var r = o > 1 ? void 0 : o ? Yi(t, i) : t, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (r = (o ? n(t, i, r) : n(r)) || r);
  return o && r && Ji(t, i, r), r;
};
const qi = {
  1: "numerical:one",
  2: "numerical:two",
  3: "numerical:three",
  4: "numerical:four",
  5: "numerical:five",
  6: "numerical:six",
  7: "numerical:seven",
  8: "numerical:eight",
  9: "numerical:nine",
  10: "numerical:ten",
  11: "numerical:eleven",
  12: "numerical:twelve",
  13: "numerical:thirteen",
  14: "numerical:fourteen",
  15: "numerical:fifteen",
  16: "numerical:sixteen",
  17: "numerical:seventeen",
  18: "numerical:eighteen",
  19: "numerical:nineteen",
  20: "numerical:twenty",
  21: "numerical:twenty-one",
  22: "numerical:twenty-two",
  23: "numerical:twenty-three",
  24: "numerical:twenty-four",
  25: "numerical:twenty-five",
  26: "numerical:twenty-six",
  27: "numerical:twenty-seven",
  28: "numerical:twenty-eight",
  29: "numerical:twenty-nine",
  30: "numerical:thirty",
  31: "numerical:thirty-one"
}, Hi = [
  "ArrowLeft",
  "ArrowRight",
  "ArrowUp",
  "ArrowDown"
], at = 704, _e = 762, st = 296, lt = 406, te = ({
  showMultipleMonths: e,
  offsetWidth: t
}) => {
  let i;
  return e ? (t >= at && t <= _e ? i = t : t > _e ? i = _e : i = at, i = (i - 8) / 2) : t > st ? t < lt ? i = t : i = lt : i = st, i;
}, Oe = (e) => e != null && e.includes("_") ? e.replace("_", "-") : e, Ui = (e) => {
  const t = document.cookie.split("; ");
  for (const i of t) {
    const o = i.split("=");
    if (o[0] === e)
      return o[1];
  }
  return null;
}, Ki = () => {
  const e = new URLSearchParams(location.search).get("locale");
  if (e)
    return Oe(e);
  const t = Ui("sessionLocale");
  return t ? Oe(t) : "en-US";
}, Ye = class Ye extends ne {
  constructor(t) {
    super(), this.store = dt({
      devTools: {
        name: "@aileron/calendar",
        trace: !0
      },
      middleware: (i) => i(),
      reducer: {
        calendar: $t
      }
    }), this._locale = "en-US", this.weekdayFormat = "narrow", this.showCurrentYear = !1, this.showPrice = !1, this.showMultipleMonths = !0, this.singleDaySelection = !1, this.manualSelection = !1, this.enablePastSelection = !1, this.setSizes = async () => {
      this.offsetWidth !== 0 && (this.handlePriceSizes(), await this.updateComplete, this.calendars.forEach(
        (i) => i.style.width = `${te({
          showMultipleMonths: this.showMultipleMonths,
          offsetWidth: this.offsetWidth
        })}px`
      ), this.multipleCalendars.style.marginLeft = `-${te({
        showMultipleMonths: this.showMultipleMonths,
        offsetWidth: this.offsetWidth
      }) + 8}px`);
    }, this.customElementString = t;
  }
  connectedCallback() {
    super.connectedCallback(), this.classList.add("adc-calendar"), Mt(
      this.customElementString ? this.customElementString + "-calendar" : "adc-calendar"
    ), Re(
      this.customElementString ? this.customElementString + "-calendar" : "adc-calendar"
    ), this.storeUnsubscribe = this.store.subscribe(
      () => this.stateChanged(this.store.getState())
    ), this.stateChanged(this.store.getState()), addEventListener("resize", this.setSizes);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.storeUnsubscribe(), removeEventListener("resize", this.setSizes);
  }
  set locale(t) {
    const i = this._locale;
    t === "" ? this._locale = Ki() : this._locale = Oe(t), this.requestUpdate("locale", i);
  }
  get locale() {
    return this._locale;
  }
  stateChanged(t) {
    this.month = t.calendar.month, this.currentDate = t.calendar.currentDate, this.firstSelection = t.calendar.firstSelection, this.secondSelection = t.calendar.secondSelection, this.modifyFirstSelection = t.calendar.modifyFirstSelection, this.dateFnsLocale = t.calendar.dateFnsLocale, this.requestUpdate();
  }
  async handlePriceSizes() {
    await this.updateComplete, this.offsetWidth < 358 ? (this.prices.forEach((t) => t.style.transform = "scale(.75)"), this.prices.forEach((t) => t.style.bottom = "0")) : (this.prices.forEach((t) => t.style.transform = ""), this.prices.forEach((t) => t.style.bottom = ""));
  }
  firstUpdated() {
    this.store.dispatch(Vi()), this.store.dispatch(
      Pi({
        date: this.minDateString || this.currentDate
      })
    ), this.setSizes(), this.multipleCalendars.addEventListener("transitionend", () => {
      const t = ["transition-transform", "duration-200"];
      this.multipleCalendars.style.transform.includes("-") ? (this.store.dispatch(Ii()), N(this, "adc-next-month-animation-end")) : this.multipleCalendars.style.transform.includes("-") || (this.store.dispatch(zi()), N(this, "adc-prev-month-animation-end")), t.forEach(
        (i) => this.multipleCalendars.classList.remove(i)
      ), this.calendars.forEach(
        (i, o) => o === 0 || o === 3 || !this.showMultipleMonths && o === 2 ? i.classList.add("invisible") : null
      ), this.multipleCalendars.style.transform = "none";
    });
  }
  updated(t) {
    if (t.has("locale")) {
      if (this.locale.split("-").length === 1)
        this.store.dispatch(
          P({ name: "dateFnsLocale", value: this.locale })
        );
      else {
        const i = this.locale.split("-").join("");
        _[i] !== void 0 ? this.store.dispatch(
          P({ name: "dateFnsLocale", value: i })
        ) : this.store.dispatch(
          P({
            name: "dateFnsLocale",
            value: this.locale.split("-")[0]
          })
        );
      }
      this.store.dispatch(P({ name: "locale", value: this.locale }));
    }
    t.has("showMultipleMonths") && this.store.dispatch(
      ji(!t.get("showMultipleMonths"))
    );
  }
  nextMonthAnimation(t) {
    N(this, "adc-next-month-animation-start"), this.calendars.forEach(
      (i) => i.classList.remove("invisible")
    ), t.classList.add("transition-transform"), t.classList.add("duration-200"), t.style.transform = `translateX(-${te({
      showMultipleMonths: this.showMultipleMonths,
      offsetWidth: this.offsetWidth
    }) + 8}px)`;
  }
  prevMonthAnimation(t) {
    N(this, "adc-prev-month-animation-start"), this.calendars.forEach(
      (i) => i.classList.remove("invisible")
    ), t.classList.add("transition-transform"), t.classList.add("duration-200"), t.style.transform = `translateX(${te({
      showMultipleMonths: this.showMultipleMonths,
      offsetWidth: this.offsetWidth
    }) + 8}px)`;
  }
  handleSelectDay(t, i, o) {
    i || (this.singleDaySelection ? this.store.dispatch(
      be({
        firstSelection: t,
        manualSelection: this.manualSelection
      })
    ) : this.manualSelection ? this.modifyFirstSelection ? this.store.dispatch(
      be({
        firstSelection: t,
        manualSelection: this.manualSelection
      })
    ) : this.store.dispatch(
      nt({
        secondSelection: t,
        manualSelection: this.manualSelection
      })
    ) : !this.firstSelection || o ? this.store.dispatch(
      be({
        firstSelection: t,
        manualSelection: this.manualSelection
      })
    ) : this.secondSelection ? this.store.dispatch(
      be({
        firstSelection: t,
        manualSelection: this.manualSelection
      })
    ) : this.store.dispatch(
      nt({
        secondSelection: t,
        manualSelection: this.manualSelection
      })
    ), N(this, "adc-select"), (this.manualSelection ? this.modifyFirstSelection : !this.modifyFirstSelection) ? N(this, "adc-first-selection") : N(this, "adc-second-selection"));
  }
  disableMonthButton() {
    return this.enablePastSelection ? !1 : !!(this.month.length && de(
      f(this.currentDate),
      f(this.month[1].name)
    ));
  }
  handleGridRangeOver(t, i) {
    var a;
    const o = this.calendarGridContainer[1], r = this.calendarGridContainer[2];
    i === 1 ? o.classList.add("calendar__grid-range-hover") : i === 2 && (o.classList.add("calendar__grid-range-hover"), r.classList.add("calendar__grid-range-hover")), (a = t.target.parentElement) == null || a.classList.add("hovered-day");
  }
  handleGridRangeOut(t) {
    var i;
    this.calendarGridContainer.forEach((o) => {
      o.classList.remove("calendar__grid-range-hover");
    }), (i = t.target.parentElement) == null || i.classList.remove("hovered-day");
  }
  createMonthName(t) {
    return (
      // show year w/ month name if showCurrentYear is true
      this.showCurrentYear || // show year w/ month name if Year is not current dates Year
      !zt(f(t)) ? f(t).toLocaleString(this.locale, {
        month: "long",
        year: "numeric"
      }) : f(t).toLocaleString(this.locale, { month: "long" })
    );
  }
  startListeningToKeyboard() {
    this.addEventListener("keydown", this.handleKeydown);
    const t = () => {
      this.removeEventListener("keydown", this.handleKeydown), this.removeEventListener("focusout", t);
    };
    this.addEventListener("focusout", t);
  }
  handleKeydown(t) {
    const { code: i } = t;
    if (!Hi.includes(i))
      return;
    const o = this.focusedDate.parentElement.parentElement.parentElement.parentElement, r = this.focusedDate.parentElement;
    if (i === "ArrowRight")
      r.nextElementSibling ? r.nextElementSibling.querySelector(".calendar__day").focus() : this.showMultipleMonths && o.nextElementSibling && o.nextElementSibling.querySelector(".calendar__grid").firstElementChild.querySelector(".calendar__day").focus();
    else if (i === "ArrowLeft")
      r.previousElementSibling ? r.previousElementSibling.querySelector(".calendar__day").focus() : this.showMultipleMonths && o.previousElementSibling && o.previousElementSibling.querySelector(".calendar__grid").lastElementChild.querySelector(".calendar__day").focus();
    else if (i === "ArrowUp") {
      let a = r, n = 0;
      for (let s = 0; s < 7; s++) {
        if (!a.previousElementSibling) {
          if (this.showMultipleMonths && o.previousElementSibling) {
            let l = o.previousElementSibling.querySelector(
              ".calendar__grid"
            ).lastElementChild;
            for (s = 1; s < 7 - n; s++)
              l = l.previousElementSibling;
            l.querySelector(".calendar__day").focus();
          }
          return;
        }
        n++, a = a.previousElementSibling;
      }
      a.querySelector(".calendar__day").focus();
    } else if (i === "ArrowDown") {
      let a = r, n = 0;
      for (let s = 0; s < 7; s++) {
        if (!a.nextElementSibling) {
          if (this.showMultipleMonths && o.nextElementSibling) {
            let l = o.nextElementSibling.querySelector(
              ".calendar__grid"
            ).firstElementChild;
            for (s = 1; s < 7 - n; s++)
              l = l.nextElementSibling;
            l.querySelector(".calendar__day").focus();
          }
          return;
        }
        n++, a = a.nextElementSibling;
      }
      a.querySelector(".calendar__day").focus();
    }
    t.preventDefault();
  }
  handleFocus(t) {
    t.target.classList.add("adc-calendar-day--has-focus");
  }
  handleBlur(t) {
    t.target.classList.remove("adc-calendar-day--has-focus");
  }
  createTagName(t) {
    return ze(
      this.customElementString ? this.customElementString + t : "adc" + t
    );
  }
  render() {
    this.setSizes();
    const t = () => E`
        <div
          class="calendar__weekdays text-center grid grid-cols-7 m-0.5 w-full justify-items-center
      ${L({
      "first:pr-2": this.showMultipleMonths
    })}
      "
        >
          ${Array(7).fill(null).map((i, o) => {
      const r = Pt(/* @__PURE__ */ new Date(), {
        locale: _[this.dateFnsLocale]
      }), a = new Date(
        r.getFullYear(),
        r.getMonth(),
        r.getDate() + o
      );
      let n;
      this.weekdayFormat === "short" ? n = this.dateFnsLocale !== "ptBR" ? "E" : "EEEEEE" : n = "EEEEE";
      const s = ht(a, n, {
        locale: _[this.dateFnsLocale]
      });
      return E`
                <div
                  class="calendar__weekday flex items-center justify-center rounded text-neutral-060 w-12 h-12 m-0.5 bg-transparent text-[14px] font-sans font-[400] leading-4"
                >
                  ${s}
                </div>
              `;
    })}
        </div>
      `;
    return E`
      <div
        class="overflow-hidden
          ${L({
      "max-w-[406px]": !this.showMultipleMonths,
      "min-w-[296px]": !this.showMultipleMonths,
      "max-w-[762px]": this.showMultipleMonths,
      "min-w-[704px]": this.showMultipleMonths
    })}
        "
      >
        <!-- Arrows container -->
        <div class="relative">
          <div
            class="calendar__navigation--container flex absolute top-0 z-10 w-full
            ${L({
      "max-w-[406px]": !this.showMultipleMonths,
      "min-w-[296px]": !this.showMultipleMonths,
      "max-w-[762px]": this.showMultipleMonths,
      "min-w-[704px]": this.showMultipleMonths
    })}
            "
          >
            <div class="m-0.5 w-full justify-between flex">
              ${E`<${this.createTagName("-calendar-calendar-navigation")}
                  ?disabled=${this.disableMonthButton()}
                  class="p-0.5 bg-neutral-140 ${L({
      "pointer-events-none": this.disableMonthButton()
    })}"
                  icon="navigation:chevron-left"
                  @click=${() => this.prevMonthAnimation(this.multipleCalendars)}
                  >Previous Month</${this.createTagName(
      "-calendar-calendar-navigation"
    )}
                >
                <${this.createTagName("-calendar-calendar-navigation")}
                  class="p-0.5 bg-neutral-140"
                  icon="navigation:chevron-right"
                  @click=${() => this.nextMonthAnimation(this.multipleCalendars)}
                  >Next Month</${this.createTagName(
      "-calendar-calendar-navigation"
    )}
                > `}
            </div>
          </div>
        </div>

        <!-- Week Days Container -->

        <div class="relative">
          <div
            class="flex absolute top-16 w-full
          ${L({
      "max-w-[406px]": !this.showMultipleMonths,
      "min-w-[296px]": !this.showMultipleMonths,
      "max-w-[762px]": this.showMultipleMonths,
      "min-w-[704px]": this.showMultipleMonths
    })}
          "
          >
            ${t()}
            ${this.showMultipleMonths ? t() : ""}
          </div>
        </div>

        <!-- Calendar Grids -->
        <div
          @focusin=${this.startListeningToKeyboard}
          class="multiple-calendars grid translate-x-0 min-w-[1120px] gap-2"
          style="
          grid-template-columns: repeat(4, 1fr);
          margin-left: -${te({
      showMultipleMonths: this.showMultipleMonths,
      offsetWidth: this.offsetWidth
    }) + 8}px;
        "
        >
          ${this.month.map((i, o) => E`
              <div
                class="calendar
              ${L({
      invisible: o === 0 || o === 3 || !this.showMultipleMonths && o === 2,
      "max-w-[406px]": !this.showMultipleMonths,
      "min-w-[296px]": !this.showMultipleMonths,
      "max-w-[377px]": this.showMultipleMonths,
      "min-w-[348px]": this.showMultipleMonths
    })}"
                style="width: ${te({
      showMultipleMonths: this.showMultipleMonths,
      offsetWidth: this.offsetWidth
    })}px;"
              >
                <div class=" grid grid-cols-7 p-2 mb-2 h-14">
                  <div
                    class="
                flex
                justify-center
                items-center
                calendar-month
                calendar__month
                text-neutral-000
                font-sans
                text-center
                col-span-7
                "
                  >
                    ${this.createMonthName(i.name)}
                  </div>
                </div>
                <div
                  class="calendar__weekday-grid-container p-0.5 mt-[60px] h-[349px]"
                >
                  <div
                    class="calendar__grid grid grid-cols-7 justify-items-center gap-1 p-0.5 ${L(
      {
        "calendar__grid-range-enabled": (this.manualSelection ? !this.modifyFirstSelection : !0) && !this.singleDaySelection && !this.secondSelection
      }
    )}"
                  >
                    ${i.days.map((r, a) => {
      let n = !1, s = !1, l = !1, d = !1, c = !1;
      const h = () => this.maxDaysOut ? ft(/* @__PURE__ */ new Date(), {
        days: this.maxDaysOut
      }).toISOString() : "";
      typeof r.date == "string" && (n = A(
        I(f(r.date)),
        I(f(this.currentDate))
      ), s = A(
        I(f(r.date)),
        I(f(this.minDateString))
      ), l = Ie(
        I(f(r.date)),
        I(
          f(
            this.maxDateString || h()
          )
        )
      ), d = A(
        f(r.date),
        f(this.firstSelection)
      ), c = A(
        f(this.firstSelection),
        f(r.date)
      ));
      const p = l || s || n && !this.enablePastSelection || this.manualSelection && !this.modifyFirstSelection && d;
      return E`
                        <div
                          class="calendar__day--wrapper relative w-full ${L(
        {
          first__day: a === 0,
          "calendar__day--departure-wrapper": r.isDeparture,
          "calendar__day--after-departure-month-wrapper": a === 0 && c
        }
      )}
                            "
                          style="${a === 0 ? mt({
        gridColumnStart: this.month[o].firstDayOfMonth
      }) : void 0}
                       "
                        >
                          ${this.showPrice ? E`<div
                                  class="calendar__day--price font-sans font-[400] text-[12px] leading-4 text-center pointer-events-none w-full absolute bottom-[7px]
                        ${L({
        "text-green-060": !r.isDeparture && !r.isArrival,
        "text-neutral-140": r.isDeparture || r.isArrival
      })}
                        "
                                >
                                  $9,999
                                </div>` : ""}

                          <${this.createTagName("-calendar-button-icon")}
                            @focus=${this.handleFocus}
                            @blur=${this.handleBlur}
                            icon="${qi[r.value]}"
                            size="sm"
                            icon-size="16"
                            type="button"
                            kind="ghost"
                            data-date=${r.date}
                            ?disabled=${p}
                            @mouseover=${(u) => this.handleGridRangeOver(u, o)}
                            @mouseout=${(u) => this.handleGridRangeOut(u)}
                            @click=${() => this.handleSelectDay(
        r.date,
        p,
        d
      )}
                            class="calendar__day rounded w-full aspect-square ${L(
        {
          first__day: a === 0,
          "calendar__day-show-price": this.showPrice,
          "calendar__day--departure": r.isDeparture,
          "calendar__day--after-departure-month": a === 0 && c,
          "calendar__day--arrival": r.isArrival,
          "calendar__day--highlight-day": r.isArrival && !this.modifyFirstSelection && this.manualSelection && !this.singleDaySelection && this.firstSelection && this.secondSelection || r.isDeparture && this.modifyFirstSelection && this.manualSelection && !this.singleDaySelection && this.firstSelection && this.secondSelection,
          border: r.isToday && !r.isDeparture && !r.isArrival,
          "border-solid": r.isToday && !r.isDeparture && !r.isArrival,
          "border-[#637E9C]": r.isToday && !r.isDeparture && !r.isArrival,
          "bg-blue-120": !r.isArrival && !r.isDeparture && r.isInRange,
          "text-neutral-010": l || s || n && !this.enablePastSelection,
          "text-neutral-140": r.isDeparture || r.isArrival,
          "text-neutral-090": p,
          "hover:bg-neutral-130": !c && !r.isDeparture && !r.isArrival && !r.isInRange || this.firstSelection && this.secondSelection && !r.isInRange && !r.isArrival && !r.isDeparture,
          // grey
          "active:bg-neutral-120": !r.isDeparture && !r.isArrival && !r.isInRange && !c || this.firstSelection && this.secondSelection && !r.isInRange && !r.isArrival && !r.isDeparture,
          // grey
          "calendar__day--disabled": l || n || s,
          "hover:bg-blue-120": this.firstSelection && !this.secondSelection && !r.isDeparture && !r.isArrival && !r.isInRange && c && !this.singleDaySelection,
          // light blue
          "active:bg-blue-100": this.firstSelection && !this.secondSelection && !r.isDeparture && !r.isArrival && !r.isInRange && c && !this.singleDaySelection || !r.isDeparture && !r.isArrival && r.isInRange,
          // light blue
          "hover:bg-blue-110": !r.isDeparture && !r.isArrival && r.isInRange,
          // light blue
          "bg-blue-060": r.isDeparture || r.isArrival,
          // dark blue
          "active:bg-blue-080": r.isDeparture || r.isArrival,
          // dark blue
          "hover:bg-blue-070": r.isDeparture || r.isArrival,
          // dark blue
          "pointer-events-none": p || this.manualSelection && d && !this.modifyFirstSelection
        }
      )}"
                          >
                            <slot>${r.screenReader}</slot>
                          </${this.createTagName("-calendar-button-icon")}>
                        </div>
                      `;
    })}
                  </div>
                </div>
              </div>
            `)}
        </div>
      </div>
    `;
  }
};
Ye.styles = [ne.styles || [], Te(We)];
let k = Ye;
D([
  y({ type: Object })
], k.prototype, "store", 2);
D([
  M()
], k.prototype, "month", 2);
D([
  M()
], k.prototype, "currentDate", 2);
D([
  M()
], k.prototype, "firstSelection", 2);
D([
  M()
], k.prototype, "secondSelection", 2);
D([
  M()
], k.prototype, "modifyFirstSelection", 2);
D([
  M()
], k.prototype, "dateFnsLocale", 2);
D([
  De(".calendar__grid")
], k.prototype, "calendarGridContainer", 2);
D([
  De(".calendar__day")
], k.prototype, "calendarDays", 2);
D([
  De(".calendar")
], k.prototype, "calendars", 2);
D([
  De(".calendar__day--price")
], k.prototype, "prices", 2);
D([
  q(".multiple-calendars")
], k.prototype, "multipleCalendars", 2);
D([
  q(".adc-calendar-day--has-focus")
], k.prototype, "focusedDate", 2);
D([
  y({ reflect: !0 })
], k.prototype, "locale", 1);
D([
  y({ reflect: !0, attribute: "min-date-string" })
], k.prototype, "minDateString", 2);
D([
  y({ reflect: !0, attribute: "max-date-string" })
], k.prototype, "maxDateString", 2);
D([
  y({ reflect: !0, attribute: "max-days-out" })
], k.prototype, "maxDaysOut", 2);
D([
  y({
    reflect: !0,
    attribute: "weekday-format",
    converter: (e) => e === "short" || e === "narrow" ? e : "narrow"
  })
], k.prototype, "weekdayFormat", 2);
D([
  y({ reflect: !0, type: Boolean, attribute: "show-current-year" })
], k.prototype, "showCurrentYear", 2);
D([
  y({ reflect: !0, type: Boolean, attribute: "show-price" })
], k.prototype, "showPrice", 2);
D([
  y({ reflect: !0, type: Boolean, attribute: "show-multiple-months" })
], k.prototype, "showMultipleMonths", 2);
D([
  y({ reflect: !0, type: Boolean, attribute: "single-day-selection" })
], k.prototype, "singleDaySelection", 2);
D([
  y({ reflect: !0, type: Boolean, attribute: "manual-selection" })
], k.prototype, "manualSelection", 2);
D([
  y({ type: Boolean, attribute: "enable-past-selection" })
], k.prototype, "enablePastSelection", 2);
try {
  customElements.define("adc-calendar", k);
} catch {
}
function Lt(e) {
  try {
    customElements.define(
      `${e}-calendar`,
      class extends k {
        constructor() {
          super(e);
        }
      }
    );
  } catch {
  }
}
var Gi = Object.defineProperty, Xi = Object.getOwnPropertyDescriptor, g = (e, t, i, o) => {
  for (var r = o > 1 ? void 0 : o ? Xi(t, i) : t, a = e.length - 1, n; a >= 0; a--)
    (n = e[a]) && (r = (o ? n(t, i, r) : n(r)) || r);
  return o && r && Gi(t, i, r), r;
};
class vo {
  constructor() {
    this.locale = "en-US", this.weekdayFormat = "narrow", this.showCurrentYear = !0, this.showPrice = !1;
  }
}
const Ne = (e) => e != null && e.includes("_") ? e.replace("_", "-") : e, Qi = (e) => {
  const t = document.cookie.split("; ");
  for (const i of t) {
    const o = i.split("=");
    if (o[0] === e)
      return o[1];
  }
  return null;
}, Zi = () => {
  const e = new URLSearchParams(location.search).get("locale");
  if (e)
    return Ne(e);
  const t = Qi("sessionLocale");
  return t ? Ne(t) : "en-US";
}, eo = (e) => {
  const t = [];
  let i = "";
  return e.split("").forEach((o, r) => {
    o.match("[A-Za-z0-9]") ? i += o : (i.length > 0 && t.push(i), i = ""), r === e.split("").length - 1 && i.length > 0 && t.push(i);
  }), t.join("-"), t;
};
function Et(e) {
  const t = [], i = { month: "long" }, o = new Intl.DateTimeFormat(e, i);
  for (let r = 0; r < 12; r++) {
    const a = o.format(new Date(Date.UTC(2e3, r + 1, 1)));
    t.push(a);
  }
  return t;
}
const to = (e, t) => {
  const i = Et(t);
  let o;
  return i.forEach((r, a) => {
    r.toLowerCase().includes(e.toLowerCase()) && (o = a + 1);
  }), o || e;
}, ct = (e, t) => {
  const i = Et(t);
  let o = null;
  return i.forEach((r, a) => {
    const n = e.findIndex(
      (s) => r.toLowerCase().includes(s.toLowerCase())
    );
    n !== -1 && (o = [n, a + 1]);
  }), o;
}, io = (e) => {
  let t = null;
  const i = e.findIndex((o) => o.length === 4);
  return i !== -1 && (t = [i, Number(e[i])]), t;
}, oo = (e, t, i) => {
  const o = eo(e), r = new Intl.DateTimeFormat(t).formatToParts(/* @__PURE__ */ new Date()), a = [];
  r.forEach((c) => {
    (c.type === "day" || c.type === "month" || c.type === "year") && a.push(c);
  });
  const n = {
    year: 2,
    month: 0,
    day: 1
  };
  if (_[i].options.dateFormat ? _[i].options.dateFormat.split("/").forEach((c, h) => {
    c === "dd" && (n.day = h), c === "mm" && (n.month = h), c === "yyyy" && (n.year = h);
  }) : a.forEach(
    (c, h) => {
      c.type === "day" && (n.day = h), c.type === "month" && (n.month = h), c.type === "year" && (n.year = h);
    }
  ), o.length >= 3) {
    const c = o.slice(0, 3), h = ct(c, t);
    if (h) {
      c.splice(h[0], 1);
      const p = h[1], u = io(c);
      if (u) {
        c.splice(u[0], 1);
        const b = u[1], w = c[0], x = /* @__PURE__ */ new Date();
        return x.setFullYear(b), x.setMonth(Number(p) - 1, parseInt(w, 10)), x;
      } else {
        const b = c[0], w = c[1].length === 2 ? `20${c[1]}` : (/* @__PURE__ */ new Date()).getFullYear().toString(), x = /* @__PURE__ */ new Date();
        return x.setFullYear(parseInt(w, 10)), x.setMonth(Number(p) - 1, parseInt(b, 10)), x;
      }
    } else {
      const p = c[n.day], u = c[n.month], b = c[n.year].length === 2 ? `20${c[n.year]}` : c[n.year], w = /* @__PURE__ */ new Date();
      return w.setFullYear(parseInt(b, 10)), w.setMonth(Number(u) - 1, parseInt(p, 10)), w;
    }
  } else if (o.length === 2) {
    const c = ct(o, t);
    if (c) {
      o.splice(c[0], 1);
      const h = c[1], p = o[0], u = /* @__PURE__ */ new Date();
      return u.setMonth(h - 1, parseInt(p, 10)), A(u, /* @__PURE__ */ new Date()) && u.setFullYear(u.getFullYear() + 1), u;
    } else {
      let h, p;
      n.day < n.month ? (h = parseInt(o[0], 10), p = parseInt(o[1], 10)) : (h = parseInt(o[1], 10), p = parseInt(o[0], 10));
      const u = /* @__PURE__ */ new Date();
      return u.setMonth(p - 1, h), A(u, /* @__PURE__ */ new Date()) && u.setFullYear(u.getFullYear() + 1), u;
    }
  }
  const s = parseInt(o[0], 10) ? o[0] : to(o[0], t), l = /* @__PURE__ */ new Date();
  return l.setMonth(parseInt(s, 10) - 1, 1), A(l, /* @__PURE__ */ new Date()) && l.setFullYear(l.getFullYear() + 1), l;
}, we = (e, t) => {
  if (_[t].options.dateFormat) {
    let o = _[t].options.dateFormat;
    return _[t].options.yearMask && (o = o.replace(
      "yyyy",
      _[t].options.yearMask
    )), _[t].options.dayMask && (o = o.replace(
      "dd",
      _[t].options.dayMask
    )), o;
  }
  return new Intl.DateTimeFormat(e).formatToParts(/* @__PURE__ */ new Date()).map((o) => {
    switch (o.type) {
      case "day":
        return "dd";
      case "month":
        return "mm";
      case "year":
        return "yyyy";
      default:
        return o.value;
    }
  }).join("");
}, qe = class qe extends ne {
  constructor(t) {
    super(), this.clickOutsideCalendar = (i) => {
      this.isCalendarOpen && !i.composedPath().includes(this) && this.closeCalendar();
    }, this.mobileView = !1, this.isCalendarOpen = !1, this.currentDate = "", this.firstSelectionTextField = "", this.secondSelectionTextField = "", this.firstInvalidText = "", this.secondInvalidText = "", this.lastInputClicked = !0, this.kind = "dialog", this.inputSpacing = void 0, this.weekdayFormat = "narrow", this._locale = "en-US", this._firstSelectionText = "", this._secondSelectionText = "", this.showCurrentYear = !1, this.disabled = !1, this.required = !1, this.showPrice = !1, this.singleDaySelection = !1, this.manualSelection = !1, this.removeClearDates = !1, this.inputKind = "text", this.enablePastSelection = !1, this.firstPreSelection = "", this.secondPreSelection = "", this.stackInputs = !1, this.checkWidth = () => {
      window.innerWidth - 64 >= 704 ? this.mobileView = !1 : this.mobileView = !0;
    }, this.formatDate = (i) => {
      const o = f(i), r = o.toLocaleString(this.locale, { weekday: "short" }), a = o.toLocaleString(this.locale, { month: "short" }), n = o.toLocaleString(this.locale, { day: "numeric" }), s = o.toLocaleString(this.locale, { year: "numeric" });
      return `${r}, ${a} ${n}, ${s}`;
    }, this.formatTextInputDate = (i, o) => {
      if (_[o].options.dateFormat) {
        const r = _[o].options.dateFormat.split("/");
        return r.forEach((a, n) => {
          a === "dd" && (r[n] = f(i).toLocaleString(this.locale, {
            day: "numeric"
          })), a === "mm" && (r[n] = f(i).toLocaleString(this.locale, {
            month: "numeric"
          })), a === "yyyy" && (r[n] = f(i).toLocaleString(this.locale, {
            year: "numeric"
          }));
        }), r.join("/");
      } else
        return f(i).toLocaleString(this.locale, {
          day: "numeric",
          month: "numeric",
          year: "numeric"
        });
    }, this.showCalendar = async () => {
      this.isCalendarOpen = !0, this.kind === "dialog" || this.inputKind === "button" || this.mobileView ? this.dialog.show() : (await this.dropdown.showDropdown(), this.dropdown.source.focus());
    }, this.focusLastInput = () => {
      var i, o, r, a;
      this.lastInputClicked ? this.inputKind === "text" ? (i = this.firstInput.querySelector(".adc-button-icon")) == null || i.focus() : (o = this.firstInputButton) == null || o.focus() : this.inputKind === "text" ? (r = this.secondInput.querySelector(".adc-button-icon")) == null || r.focus() : (a = this.secondInputButton) == null || a.focus();
    }, this.hideDialog = () => {
      this.isCalendarOpen && this.focusLastInput(), this.isCalendarOpen = !1;
    }, this.closeCalendar = () => {
      this.isCalendarOpen && this.focusLastInput(), this.isCalendarOpen = !1, this.dialog.hide(), this.dropdown.hideDropdown();
    }, this.handleInputClick = (i) => {
      if (this.disabled)
        return;
      const o = i.target, { name: r } = o, a = r.toLowerCase() === this.firstSelectionText.toLowerCase();
      this.lastInputClicked = a, this.store.dispatch(
        Bi({
          modifyFirstSelection: this.manualSelection ? a : this.modifyFirstSelection,
          minDateString: this.minDateString
        })
      ), o && o.type === "button" && (this.isCalendarOpen ? this.closeCalendar() : this.showCalendar()), o && o.type === "text" && this.isCalendarOpen && this.manualSelection && this.store.dispatch(
        P({
          name: "modifyFirstSelection",
          value: a
        })
      );
    }, this.changeTab = (i) => {
      const o = i.target, { selected: r } = o;
      this.store.dispatch(
        P({
          name: "modifyFirstSelection",
          value: r.toLowerCase() === this.firstSelectionText.toLowerCase()
        })
      ), N(this, "adc-change-calendar-tab");
    }, this.clearDatesHandler = () => {
      this.store.dispatch(Wi()), this.firstSelectionTextField = "", this.secondSelectionTextField = "", this.firstInvalidText = "", this.secondInvalidText = "", N(this, "adc-clear-dates");
    }, this.inputBlurHandler = (i, o) => {
      const r = i.target;
      (() => {
        if (i && r && r.type === "text") {
          const { value: n } = r;
          if (n.trim() === "") {
            o ? (r.value = "", this.store.dispatch(W("")), this.firstInvalidText = "", this.firstSelectionTextField = "") : (r.value = "", this.store.dispatch(j("")), this.secondInvalidText = "", this.secondSelectionTextField = "");
            return;
          }
          const s = oo(n, this.locale, this.dateFnsLocale);
          if (!(s instanceof Date) || isNaN(s.getTime())) {
            this.locale.split("-")[0] == "es" ? r.setCustomValidity(
              "Por favor verifique la fecha que ingresó"
            ) : this.locale.split("-")[0] == "fr" ? r.setCustomValidity(
              "Veuillez vérifier la date que vous avez saisie"
            ) : this.locale.split("-")[0] == "pt" ? r.setCustomValidity("Verifique a data que você digitou") : r.setCustomValidity("Please check the date you entered"), o ? (this.firstInvalidText = n, this.store.dispatch(W("")), this.firstSelectionTextField = "") : (this.secondInvalidText = n, this.store.dispatch(j("")), this.secondSelectionTextField = "");
            return;
          }
          const l = s.toISOString();
          if (o) {
            if (oe(new Date(this.firstSelection), new Date(l))) {
              r.value = this.formatTextInputDate(
                l,
                this.dateFnsLocale
              );
              return;
            }
          } else if (oe(new Date(this.secondSelection), new Date(l))) {
            r.value = this.formatTextInputDate(
              l,
              this.dateFnsLocale
            );
            return;
          }
          if (!this.enablePastSelection && A(s, f(this.currentDate))) {
            this.locale.split("-")[0] == "es" ? r.setCustomValidity("La fecha no debe ser pasada") : this.locale.split("-")[0] == "fr" ? r.setCustomValidity("La date ne doit pas être dans le passé") : this.locale.split("-")[0] == "pt" ? r.setCustomValidity("A data não deve estar no passado") : r.setCustomValidity("Date must not be in the past"), o ? this.firstInvalidText = n : this.secondInvalidText = n, o ? this.store.dispatch(W("")) : this.store.dispatch(j("")), o ? this.firstSelectionTextField = "" : this.secondSelectionTextField = "";
            return;
          }
          if (!o && this.firstSelection && A(s, f(this.firstSelection))) {
            o ? this.firstInvalidText = n : this.secondInvalidText = n, this.locale.split("-")[0] == "es" ? r.setCustomValidity(`
            La fecha de ${this.secondSelectionText} debe ser posterior a la fecha de ${this.firstSelectionText.toLocaleLowerCase()}
            `) : this.locale.split("-")[0] == "fr" ? r.setCustomValidity(`
            la date de ${this.secondSelectionText} doit être postérieure à la date ${this.firstSelectionText.toLocaleLowerCase()}
            `) : this.locale.split("-")[0] == "pt" ? r.setCustomValidity(`
            a data de ${this.secondSelectionText} deve ser posterior à data de ${this.firstSelectionText.toLowerCase()}
            `) : r.setCustomValidity(
              `${this.secondSelectionText} date must be after the ${this.firstSelectionText.toLowerCase()} date`
            ), o ? this.store.dispatch(W("")) : this.store.dispatch(j("")), o ? this.firstSelectionTextField = "" : this.secondSelectionTextField = "";
            return;
          }
          if (o && this.secondSelection && A(f(this.secondSelection), s)) {
            o ? this.firstInvalidText = n : this.secondInvalidText = n, this.locale.split("-")[0] == "es" ? r.setCustomValidity(`
            La fecha de ${this.firstSelectionText} debe ser anterior a la fecha de ${this.secondSelectionText.toLocaleLowerCase()}
            `) : this.locale.split("-")[0] == "fr" ? r.setCustomValidity(`
            la date de ${this.firstSelectionText} doit être antérieure à la date ${this.secondSelectionText.toLowerCase()}
            `) : this.locale.split("-")[0] == "pt" ? r.setCustomValidity(`
            a data de ${this.firstSelectionText} deve ser anterior à data de ${this.secondSelectionText.toLowerCase()}
            `) : r.setCustomValidity(
              `${this.firstSelectionText} date must be before the ${this.secondSelectionText.toLowerCase()} date`
            ), o ? this.store.dispatch(W("")) : this.store.dispatch(j("")), o ? this.firstSelectionTextField = "" : this.secondSelectionTextField = "";
            return;
          }
          if (A(I(s), I(f(this.minDateString)))) {
            o ? this.firstInvalidText = n : this.secondInvalidText = n, this.locale.split("-")[0] == "es" ? r.setCustomValidity(`
            La fecha de ${o ? this.firstSelectionText : this.secondSelectionText} debe ser posterior a la fecha mínima
            `) : this.locale.split("-")[0] == "fr" ? r.setCustomValidity(`
            la date de ${o ? this.firstSelectionText : this.secondSelectionText} doit être postérieure à la date minimale
            `) : this.locale.split("-")[0] == "pt" ? r.setCustomValidity(`
            a data de ${o ? this.firstSelectionText : this.secondSelectionText} deve ser posterior à data mínima
            `) : r.setCustomValidity(`
            ${o ? this.firstSelectionText : this.secondSelectionText} date must be after the minimum date
            `), o ? this.store.dispatch(W("")) : this.store.dispatch(j("")), o ? this.firstSelectionTextField = "" : this.secondSelectionTextField = "";
            return;
          }
          const d = () => this.maxDaysOut ? ft(/* @__PURE__ */ new Date(), { days: this.maxDaysOut }).toISOString() : "";
          if ((this.maxDateString || this.maxDaysOut) && Ie(
            I(s),
            I(
              this.maxDateString ? f(this.maxDateString) : f(d())
            )
          )) {
            o ? this.firstInvalidText = n : this.secondInvalidText = n, this.locale.split("-")[0] == "es" ? r.setCustomValidity(`
            la fecha de ${o ? this.firstSelectionText : this.secondSelectionText} debe ser anterior a la fecha máxima
            `) : this.locale.split("-")[0] == "fr" ? r.setCustomValidity(`
            la date de ${o ? this.firstSelectionText : this.secondSelectionText} doit être antérieure à la date maximale
            `) : this.locale.split("-")[0] == "pt" ? r.setCustomValidity(`
            a data de ${o ? this.firstSelectionText : this.secondSelectionText} deve ser anterior à data máxima
            `) : r.setCustomValidity(
              `${o ? this.firstSelectionText : this.secondSelectionText} date must be before the maximum date`
            ), o ? this.store.dispatch(W("")) : this.store.dispatch(j("")), o ? this.firstSelectionTextField = "" : this.secondSelectionTextField = "";
            return;
          }
          o ? (this.firstInvalidText = "", this.store.dispatch(W(l))) : (this.secondInvalidText = "", this.store.dispatch(j(l)));
        }
      })(), o ? N(this, "adc-first-input-blur") : N(this, "adc-second-input-blur");
    }, this.textInputKeydown = (i) => {
      const o = i.target, { code: r } = i, { name: a } = o;
      r === "Enter" && this.inputBlurHandler(
        i,
        a.toLowerCase() === this.firstSelectionText.toLowerCase()
      );
    }, this.escapeKeyHandler = (i) => {
      const { code: o } = i;
      o === "Escape" && this.closeCalendar();
    }, this.setFirstInputValidation = (i) => {
      this.firstInput.setCustomValidity(i), this.firstInvalidText = this.firstInput.value;
    }, this.setSecondInputValidation = (i) => {
      this.secondInput.setCustomValidity(i), this.secondInvalidText = this.secondInput.value;
    }, this.renderClearDatesText = () => this.locale.split("-")[0] == "es" ? "Borrar fechas" : this.locale.split("-")[0] == "fr" ? "Effacer les dates" : this.locale.split("-")[0] == "pt" ? "Limpar datas" : "Clear dates", this.renderDoneText = () => this.locale.split("-")[0] == "es" ? "Hecho" : this.locale.split("-")[0] == "fr" ? "Fait" : this.locale.split("-")[0] == "pt" ? "Feito" : "Done", this.renderSelectDateText = () => this.locale.split("-")[0] == "es" ? "Seleccione fecha" : this.locale.split("-")[0] == "fr" ? "Sélectionner une date" : this.locale.split("-")[0] == "pt" ? "Selecione a data" : "Select date", this.renderDepartureText = () => this.locale.split("-")[0] == "es" ? "Partida" : this.locale.split("-")[0] == "fr" ? "Départ" : this.locale.split("-")[0] == "pt" ? "Partida" : "Departure", this.renderArrivalText = () => this.locale.split("-")[0] == "es" ? "Llegada" : this.locale.split("-")[0] == "fr" ? "Arrivée" : this.locale.split("-")[0] == "pt" ? "Chegada" : "Arrival", this.customElementString = t;
  }
  async connectedCallback() {
    super.connectedCallback(), this.classList.add("adc-date-picker"), Re(
      this.customElementString ? this.customElementString + "-date-picker" : "adc-date-picker"
    ), At(
      this.customElementString ? this.customElementString + "-date-picker" : "adc-date-picker"
    ), Ot(
      this.customElementString ? this.customElementString + "-date-picker" : "adc-date-picker"
    ), Nt(
      this.customElementString ? this.customElementString + "-date-picker" : "adc-date-picker"
    ), Rt(
      this.customElementString ? this.customElementString + "-date-picker" : "adc-date-picker"
    ), _t(
      this.customElementString ? this.customElementString + "-date-picker" : "adc-date-picker"
    ), Lt(
      this.customElementString ? this.customElementString + "-date-picker" : "adc-date-picker"
    ), this.store = dt({
      devTools: {
        name: "@aileron/calendar",
        trace: !0
      },
      middleware: (o) => o(),
      reducer: {
        calendar: $t
      }
    }), this.storeUnsubscribe = this.store.subscribe(
      () => this.stateChanged(this.store.getState())
    ), this.stateChanged(this.store.getState()), window.addEventListener("resize", this.checkWidth);
    const t = await this.calendarDropdown, i = await this.calendarAnchor;
    this.dropdown = new Ci(i, t), t.addEventListener("focusout", (o) => {
      t.contains(o.relatedTarget) || this.closeCalendar();
    }), window.addEventListener("click", this.clickOutsideCalendar);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this.storeUnsubscribe(), window.removeEventListener("click", this.clickOutsideCalendar), window.removeEventListener("resize", this.checkWidth);
  }
  set locale(t) {
    const i = this._locale;
    t === "" ? this._locale = Zi() : this._locale = Ne(t), this.requestUpdate("locale", i);
  }
  get locale() {
    return this._locale;
  }
  get firstSelectionText() {
    return this._firstSelectionText ? this._firstSelectionText : this.renderDepartureText();
  }
  set firstSelectionText(t) {
    const i = this._firstSelectionText;
    this._firstSelectionText = t, this.requestUpdate("firstSelectionText", i);
  }
  get secondSelectionText() {
    return this._secondSelectionText ? this._secondSelectionText : this.renderArrivalText();
  }
  set secondSelectionText(t) {
    const i = this._secondSelectionText;
    this._secondSelectionText = t, this.requestUpdate("secondSelectionText", i);
  }
  /**
   * @private
   */
  setCalendarOpen(t) {
    this.isCalendarOpen = t;
  }
  /**
   * @private
   */
  async updated(t) {
    t.has("secondPreSelection") && this.store.dispatch(
      P({ name: "secondSelection", value: this.secondPreSelection })
    ), t.has("firstPreSelection") && this.store.dispatch(
      P({ name: "firstSelection", value: this.firstPreSelection })
    ), t.has("manualSelection") && this.store.dispatch(
      P({ name: "manualSelection", value: this.manualSelection })
    ), t.has("mobileView") && t.get("mobileView") !== void 0 && (this.dropdown || this.dialog) && (this.mobileView ? (this.calendar.showMultipleMonths = !1, this.isCalendarOpen && (this.dropdown.hideDropdown(), await setTimeout(() => {
      this.dialog.show();
    }, 400))) : (this.calendar.showMultipleMonths = !0, this.isCalendarOpen && this.kind === "dropdown" && (this.dialog.hide(), await setTimeout(() => {
      this.dropdown.showDropdown();
    }, 400))));
  }
  /**
   * @private
   */
  firstUpdated() {
    this.dialog.addEventListener(
      "adc-show",
      () => setTimeout(() => {
        this.calendar.setSizes();
      }, 10)
    ), this.checkWidth();
  }
  /**
   * @private
   */
  stateChanged(t) {
    this.firstSelection = t.calendar.firstSelection, t.calendar.firstSelection && (this.firstSelectionTextField = t.calendar.firstSelection, this.firstInvalidText = ""), this.secondSelection = t.calendar.secondSelection, t.calendar.secondSelection && (this.secondSelectionTextField = t.calendar.secondSelection, this.secondInvalidText = ""), this.modifyFirstSelection = t.calendar.modifyFirstSelection, this.currentDate = t.calendar.currentDate, this.dateFnsLocale = t.calendar.dateFnsLocale, this.requestUpdate();
  }
  createTagName(t) {
    return ze(
      this.customElementString ? this.customElementString + t : "adc" + t
    );
  }
  render() {
    return E`
      <div
        id="calendar-anchor"
        class="grid gap-1.5 ${L({
      "grid-flow-col": !this.stackInputs,
      "grid-flow-row": this.stackInputs
    })}"
        style="${mt({
      gap: this.inputSpacing ? `${this.inputSpacing}px` : void 0
    })}"
        @keydown=${this.escapeKeyHandler}
      >
        <${this.createTagName("-date-picker-dialog")}
          id="dialog"
          variant=${this.mobileView ? "fullscreen" : "message"}
          ?no-close-button=${!0}
          class="dialog-container"
          ?open=${!1}
          @adc-request-close=${() => this.hideDialog()}
        >
          <div
            class="
        calendar
        grid
        gap-2
        "
          >
            ${this.singleDaySelection ? void 0 : E`
                    <${this.createTagName("-date-picker-tabs")}
                      @change=${this.changeTab}
                      ?disabled="${!1}"
                      ?underline=${!0}
                      ?auto="${!1}"
                      ?shouldAnimate="${!1}"
                      selected=${this.modifyFirstSelection ? this.firstSelectionText : this.secondSelectionText}
                      class="min-w-[296px] ${L({
      "pointer-events-none": !this.manualSelection
    })}"
                    >
                      <${this.createTagName("-date-picker-tab")}
                        ?read-only=${!this.manualSelection && this.modifyFirstSelection}
                        sub-label=${this.firstSelection ? this.formatDate(this.firstSelection) : this.modifyFirstSelection ? this.renderSelectDateText() : "--"}
                        value=${this.firstSelectionText}
                        icon-outlined
                      >
                        ${this.firstSelectionText}
                      </${this.createTagName("-date-picker-tab")}>
                      <${this.createTagName("-date-picker-tab")}
                        ?read-only=${!this.manualSelection && !this.modifyFirstSelection}
                        sub-label=${this.secondSelection ? this.formatDate(this.secondSelection) : this.modifyFirstSelection ? "--" : this.renderSelectDateText()}
                        icon-outlined
                        label=${this.secondSelectionText}
                        value=${this.secondSelectionText}
                      >
                        ${this.secondSelectionText}
                      </${this.createTagName("-date-picker-tab")}>
                    </${this.createTagName("-date-picker-tabs")}>
                  `}

            <${this.createTagName("-date-picker-calendar")}
              .store=${this.store}
              id="calendar"
              class="flex justify-center min-w-[296px]"
              locale=${this.locale}
              weekday-format=${this.weekdayFormat}
              min-date-string=${this.minDateString}
              max-date-string=${this.maxDateString}
              max-days-out=${this.maxDaysOut}
              ?show-current-year=${this.showCurrentYear}
              ?show-price=${this.showPrice}
              ?single-day-selection=${this.singleDaySelection}
              ?manual-selection=${this.manualSelection}
              ?enable-past-selection=${this.enablePastSelection}
            ></${this.createTagName("-date-picker-calendar")}>
          </div>
          <div
            id="dialogCalendarFooter"
            class="flex w-full mx-1
          ${L({
      "justify-between": !this.removeClearDates,
      "justify-end": this.removeClearDates
    })}
          "
            slot="footer"
          >
            ${this.removeClearDates ? "" : E`
                    <${this.createTagName("-date-picker-button")}
                      kind="ghost"
                      @click=${this.clearDatesHandler}
                      >${this.renderClearDatesText()}</${this.createTagName(
      "-date-picker-button"
    )}
                    >
                  `}
            <${this.createTagName("-date-picker-button")}
             @click=${this.closeCalendar}
              >${this.renderDoneText()}</${this.createTagName(
      "-date-picker-button"
    )}
            >
          </div>
        </${this.createTagName("-date-picker-dialog")}>

        ${this.inputKind === "button" ? E`
                <${this.createTagName("-date-picker-text-input")}
                  id="first-input-button"
                  ?disabled=${this.disabled}
                  label-text=${this.firstSelectionText}
                  name=${this.firstSelectionText}
                  placeholder=${we(
      this.locale,
      this.dateFnsLocale
    )}
                  ?required=${this.required}
                  
                  @click=${this.handleInputClick}
                  hide-clear-button
                  leading-icon="operation:calendar-alt"
                  type="button"
                  value="${this.firstSelectionTextField ? this.formatTextInputDate(
      this.firstSelectionTextField,
      this.dateFnsLocale
    ) : this.renderSelectDateText()}"
                >
                </${this.createTagName("-date-picker-text-input")}>

                ${this.singleDaySelection ? void 0 : E`
                      <${this.createTagName("-date-picker-text-input")}
                        id="second-input-button"
                        ?disabled=${this.disabled}
                        label-text=${this.secondSelectionText}
                        name=${this.secondSelectionText}
                        placeholder=${we(
      this.locale,
      this.dateFnsLocale
    )}
                        ?required=${this.required}
                        
                        @click=${this.handleInputClick}
                        hide-clear-button
                        leading-icon="operation:calendar-alt"
                        type="button"
                        value="${this.secondSelectionTextField ? this.formatTextInputDate(
      this.secondSelectionTextField,
      this.dateFnsLocale
    ) : this.renderSelectDateText()}"
                      >
                      </${this.createTagName("-date-picker-text-input")}>
                    `}
              ` : E`
                <${this.createTagName("-date-picker-text-input")}
                  id="first-input"
                  class="${L({
      "modify-selection-highlight": this.modifyFirstSelection && this.isCalendarOpen && !this.singleDaySelection && this.manualSelection
    })}"
                  ?disabled=${this.disabled}
                  label-text=${this.firstSelectionText}
                  name=${this.firstSelectionText}
                  placeholder=${we(
      this.locale,
      this.dateFnsLocale
    )}
                  ?required=${this.required}
                  
                  @blur="${(t) => this.inputBlurHandler(t, !0)}"
                  @click=${this.handleInputClick}
                  @keydown=${this.textInputKeydown}
                  hide-clear-button
                  value="${this.firstInvalidText ? this.firstInvalidText : this.firstSelectionTextField ? this.formatTextInputDate(
      this.firstSelectionTextField,
      this.dateFnsLocale
    ) : ""}"
                >
                  <${this.createTagName("-date-picker-button-icon")}
                    name=${this.firstSelectionText}
                    slot="button-icon"
                    icon="operation:calendar-alt"
                    >${`open calendar ${this.firstSelectionText}`}</${this.createTagName(
      "-date-picker-button-icon"
    )}
                  >
                </${this.createTagName("-date-picker-text-input")}>

                ${this.singleDaySelection ? void 0 : E`
                      <${this.createTagName("-date-picker-text-input")}
                        id="second-input"
                        class=" ${L({
      "modify-selection-highlight": !this.modifyFirstSelection && this.isCalendarOpen && !this.singleDaySelection && this.manualSelection
    })}"
                        ?disabled=${this.disabled}
                        label-text=${this.secondSelectionText}
                        name=${this.secondSelectionText}
                        placeholder=${we(
      this.locale,
      this.dateFnsLocale
    )}
                        ?required=${this.required}
                        
                        value="${this.secondInvalidText ? this.secondInvalidText : this.secondSelectionTextField ? this.formatTextInputDate(
      this.secondSelectionTextField,
      this.dateFnsLocale
    ) : ""}"
                        @blur="${(t) => this.inputBlurHandler(t, !1)}"
                        @click=${this.handleInputClick}
                        @keydown=${this.textInputKeydown}
                        hide-clear-button
                      >
                        <${this.createTagName("-date-picker-button-icon")}
                          name=${this.secondSelectionText}
                          slot="button-icon"
                          icon="operation:calendar-alt"
                          >${`open calendar ${this.secondSelectionText}`}</${this.createTagName(
      "-date-picker-button-icon"
    )}
                        >
                      </${this.createTagName("-date-picker-text-input")}>
                    `}
              `}
      </div>

      <div
        tabindex="-1"
        @keydown=${this.escapeKeyHandler}
        id="calendarDropdown"
        class="
        calendar
        grid
        gap-1.5
        bg-neutral-140
        py-6
        px-5
        rounded-lg
        "
      >
        <${this.createTagName("-date-picker-calendar")}
          .store=${this.store}
          class="flex justify-center min-w-[296px] w-[704px]"
          locale=${this.locale}
          weekday-format=${this.weekdayFormat}
          min-date-string=${this.minDateString}
          max-date-string=${this.maxDateString}
          max-days-out=${this.maxDaysOut}
          ?show-current-year=${this.showCurrentYear}
          ?show-price=${this.showPrice}
          ?single-day-selection=${this.singleDaySelection}
          ?manual-selection=${this.manualSelection}
          ?enable-past-selection=${this.enablePastSelection}
        ></${this.createTagName("-date-picker-calendar")}>
        <div
          id="dropdownCalendarFooter"
          class="flex mx-1
        ${L({
      "justify-between": !this.removeClearDates,
      "justify-end": this.removeClearDates
    })}
        "
        >
          ${this.removeClearDates ? "" : E`
                  <${this.createTagName("-date-picker-button")}
                    kind="ghost"
                    @click=${this.clearDatesHandler}
                    >${this.renderClearDatesText()}</${this.createTagName(
      "-date-picker-button"
    )}
                  >
                `}

          <${this.createTagName("-date-picker-button")} @click=${this.closeCalendar}
            >${this.renderDoneText()}</${this.createTagName(
      "-date-picker-button"
    )}
          >
        </div>
      </div>
    `;
  }
};
qe.styles = [ne.styles || [], Te(We)];
let m = qe;
g([
  y({ type: Object })
], m.prototype, "store", 2);
g([
  M()
], m.prototype, "dateFnsLocale", 2);
g([
  M()
], m.prototype, "firstSelection", 2);
g([
  M()
], m.prototype, "secondSelection", 2);
g([
  M()
], m.prototype, "modifyFirstSelection", 2);
g([
  M()
], m.prototype, "mobileView", 2);
g([
  M()
], m.prototype, "isCalendarOpen", 2);
g([
  M()
], m.prototype, "currentDate", 2);
g([
  M()
], m.prototype, "firstSelectionTextField", 2);
g([
  M()
], m.prototype, "secondSelectionTextField", 2);
g([
  M()
], m.prototype, "firstInvalidText", 2);
g([
  M()
], m.prototype, "secondInvalidText", 2);
g([
  M()
], m.prototype, "lastInputClicked", 2);
g([
  q("#calendar")
], m.prototype, "calendar", 2);
g([
  pt("#calendarDropdown")
], m.prototype, "calendarDropdown", 2);
g([
  pt("#calendar-anchor")
], m.prototype, "calendarAnchor", 2);
g([
  q("#dialog")
], m.prototype, "dialog", 2);
g([
  q("#first-input")
], m.prototype, "firstInput", 2);
g([
  q("#second-input")
], m.prototype, "secondInput", 2);
g([
  q("#first-input-button")
], m.prototype, "firstInputButton", 2);
g([
  q("#second-input-button")
], m.prototype, "secondInputButton", 2);
g([
  y({ reflect: !0 })
], m.prototype, "kind", 2);
g([
  y({ reflect: !0, attribute: "min-date-string" })
], m.prototype, "minDateString", 2);
g([
  y({ reflect: !0, attribute: "max-date-string" })
], m.prototype, "maxDateString", 2);
g([
  y({ reflect: !0, attribute: "max-days-out" })
], m.prototype, "maxDaysOut", 2);
g([
  y({ reflect: !0, attribute: "input-spacing" })
], m.prototype, "inputSpacing", 2);
g([
  y({
    reflect: !0,
    attribute: "weekday-format",
    converter: (e) => e === "short" || e === "narrow" ? e : "narrow"
  })
], m.prototype, "weekdayFormat", 2);
g([
  y({ reflect: !0 })
], m.prototype, "locale", 1);
g([
  y({ reflect: !0, attribute: "first-selection-text" })
], m.prototype, "firstSelectionText", 1);
g([
  y({ reflect: !0, attribute: "second-selection-text" })
], m.prototype, "secondSelectionText", 1);
g([
  y({ reflect: !0, type: Boolean, attribute: "show-current-year" })
], m.prototype, "showCurrentYear", 2);
g([
  y({ reflect: !0, type: Boolean })
], m.prototype, "disabled", 2);
g([
  y({ reflect: !0, type: Boolean })
], m.prototype, "required", 2);
g([
  y({ reflect: !0, type: Boolean, attribute: "show-price" })
], m.prototype, "showPrice", 2);
g([
  y({ reflect: !0, type: Boolean, attribute: "single-day-selection" })
], m.prototype, "singleDaySelection", 2);
g([
  y({ reflect: !0, type: Boolean, attribute: "manual-selection" })
], m.prototype, "manualSelection", 2);
g([
  y({ reflect: !0, type: Boolean, attribute: "remove-clear-dates" })
], m.prototype, "removeClearDates", 2);
g([
  y({ reflect: !0, attribute: "input-kind" })
], m.prototype, "inputKind", 2);
g([
  y({ type: Boolean, attribute: "enable-past-selection" })
], m.prototype, "enablePastSelection", 2);
g([
  y({ reflect: !0, attribute: "first-pre-selection" })
], m.prototype, "firstPreSelection", 2);
g([
  y({ reflect: !0, attribute: "second-pre-selection" })
], m.prototype, "secondPreSelection", 2);
g([
  y({ reflect: !0, type: Boolean, attribute: "stack-inputs" })
], m.prototype, "stackInputs", 2);
try {
  customElements.define("adc-date-picker", m);
} catch {
}
function ro(e) {
  try {
    customElements.define(
      `${e}-date-picker`,
      class extends m {
        constructor() {
          super(e);
        }
      }
    );
  } catch {
  }
}
function ko(e) {
  try {
    Mt(e), Lt(e), ro(e);
  } catch {
  }
}
export {
  k as Calendar,
  vo as CalendarConfig,
  Q as CalendarNavigation,
  m as DatePicker,
  Lt as registerCalendar,
  Mt as registerCalendarNavigation,
  ko as registerComponent,
  ro as registerDatePicker
};
